var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetroRulesBgTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 330,
    height: 344,
    viewBox: "0 0 330 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_33025)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.475 77.6387H110.486V77.6533H110.475V77.6387Z",
    fill: "url(#paint0_linear_319_33025)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-22.3508 93.2625H-18.8719L-13.4109 52.5505H-12.0749L-9.18661 85.388L-7.51443 83.9377C-7.37703 83.8183 -7.19867 83.7514 -7.0145 83.7514H-3.00064C-2.81645 83.7514 -2.644 83.8154 -2.50368 83.9319L8.42406 93.2625H30.6771V81.3925C30.6771 81.2032 30.835 81.0489 31.0251 81.0489C31.2151 81.0489 31.37 80.8945 31.37 80.7052V78.2882C31.37 78.1775 31.3963 78.0668 31.4431 77.9678L34.4542 71.4941C34.5799 71.2262 34.8518 71.0543 35.15 71.0543H57.2042C57.4907 71.0543 57.7539 71.2145 57.8854 71.4679L61.0953 77.7057C61.224 77.9591 61.49 78.1192 61.7765 78.1192H61.8408C62.2617 78.1192 62.6038 78.46 62.6038 78.8793V79.3482C62.6038 79.6015 62.4781 79.8403 62.2647 79.983L62.1653 80.0471C61.9548 80.1869 61.8262 80.4257 61.8262 80.679V93.2625H66.0826L66.0593 87.6973C66.0564 87.2459 66.6995 87.1673 66.8106 87.6041L67.0678 88.6467H67.252L67.4128 87.5255C67.4771 87.0829 68.1232 87.0945 68.1729 87.5401L68.2928 88.6467H68.781L68.9418 87.5255C69.0061 87.0829 69.6522 87.0945 69.7019 87.5401L69.8129 88.571H69.9387L70.0878 87.5284C70.1521 87.0858 70.7981 87.0974 70.8478 87.543L70.9589 88.5739H71.4676L71.6167 87.5313C71.681 87.0887 72.3271 87.1003 72.3768 87.5459L72.4879 88.5768H72.6136L72.7627 87.5343C72.827 87.0916 73.4731 87.1032 73.5228 87.5488L73.6339 88.5797H73.7596L73.9087 87.5372C73.973 87.0945 74.619 87.1062 74.6687 87.5517L74.7798 88.5826H75.0809L75.3908 87.3158C75.499 86.8761 76.148 86.9576 76.1422 87.409L76.0954 93.277H81.0301V72.359H81.1675L81.2464 71.6863C81.2961 71.2465 81.9335 71.2349 82.0036 71.6717L82.1118 72.359H82.41L82.4889 71.6863C82.5386 71.2465 83.1759 71.2349 83.2461 71.6717L83.363 72.4376H86.2776L86.3653 71.6863C86.415 71.2465 87.0524 71.2349 87.1225 71.6717L87.2394 72.4376H87.5172L87.6049 71.6863C87.6546 71.2465 88.2919 71.2349 88.3621 71.6717L88.479 72.4376H88.6281V77.6067H89.2478V66.1794H89.356C89.356 66.1794 89.3589 66.159 89.3589 66.1503L89.4671 64.7612C89.5022 64.2981 90.1804 64.2894 90.2272 64.7524L90.3675 66.1415C90.3675 66.1415 90.3704 66.1532 90.3704 66.159V66.1765L90.4435 66.1794V66.1503L90.5517 64.7612C90.5868 64.2981 91.265 64.2894 91.3118 64.7524L91.4579 66.1415V66.1648V66.1794H92.5074V56.0276C92.5045 56.0043 92.5045 55.9781 92.5074 55.9519V55.8267H92.5338L92.7355 54.9996C92.8261 54.6269 93.3494 54.6094 93.4693 54.9705L93.7528 55.8238H93.9282L95.2233 51.6506L95.8548 43.4529C95.2818 43.383 94.8345 42.8938 94.8345 42.3026C94.8345 41.6619 95.3549 41.1436 96.001 41.1436C96.647 41.1436 97.1615 41.6619 97.1615 42.3026C97.1615 42.9433 96.6412 43.4616 96.001 43.4616H95.9805L96.5418 51.6506L97.9859 55.8238H98.2315L98.3017 55.451C98.3777 55.0491 98.9507 55.0316 99.0501 55.4306L99.1466 55.8267H99.4915V66.1794H99.9125V66.1503L100.021 64.7612C100.056 64.2981 100.734 64.2894 100.781 64.7524L100.927 66.1415V66.1794H102.707V66.1503L102.815 64.7612C102.851 64.2981 103.529 64.2894 103.576 64.7524L103.722 66.1415V66.1648V66.1794H103.842V77.6067H105.783V72.4376H105.932L106.049 71.6717C106.113 71.232 106.75 71.2465 106.806 71.6863L106.891 72.4376H107.174L107.288 71.6717C107.358 71.232 107.996 71.2465 108.048 71.6863L108.133 72.4376H111.051L111.168 71.6717C111.232 71.232 111.869 71.2465 111.925 71.6863L112.001 72.359H112.302L112.404 71.6717C112.474 71.232 113.112 71.2465 113.164 71.6863L113.24 72.359H113.302V93.277H121.522V87.9274C121.522 87.4702 122.183 87.4003 122.28 87.8488L122.455 88.6642H122.671V88.6554V88.6438L122.812 87.9157C122.891 87.4935 123.502 87.508 123.563 87.9332L123.671 88.6613L123.817 88.6642V88.6554C123.817 88.6554 123.817 88.6467 123.82 88.6438L123.958 87.9157C124.037 87.4935 124.648 87.508 124.709 87.9332L124.817 88.6613L125.343 88.6642V88.6438L125.484 87.9157C125.563 87.4935 126.174 87.508 126.235 87.9332L126.343 88.6613L128.398 88.6642V88.6438L128.539 87.9157C128.618 87.4935 129.229 87.508 129.29 87.9332L129.398 88.6613L130.436 88.6642L130.611 87.8488C130.708 87.4032 131.368 87.4731 131.368 87.9274V93.277H134.649V90.5017C134.649 90.3794 134.678 90.2571 134.736 90.1494L137.569 84.7764C137.698 84.526 137.961 84.3687 138.244 84.3687H142.41C142.822 84.3687 143.156 84.0367 143.156 83.6261C143.156 83.2155 143.489 82.8835 143.901 82.8835H145.375C145.796 82.8835 146.138 82.5428 146.138 82.1235V78.4425C146.138 78.0231 146.48 77.6824 146.901 77.6824H160.743C161.164 77.6824 161.506 78.0231 161.506 78.4425V82.1235C161.506 82.5428 161.848 82.8835 162.269 82.8835H162.681C163.102 82.8835 163.444 83.2243 163.444 83.6436V85.6705V133.154H-22.3508V93.2625ZM110.486 77.6387H110.475V77.6533H110.486V77.6387Z",
    fill: "url(#paint1_linear_319_33025)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.338 50.864C216.338 50.6641 216.503 50.5002 216.704 50.5002L217.239 20.3061L217.222 19.7482L217.25 19.6621L217.239 20.3061L218.134 50.5863C218.334 50.5863 218.499 50.7501 218.499 50.9501V54.5792H218.864C219.065 54.5792 219.229 54.743 219.229 54.943V56.4063C219.494 56.6479 219.672 56.9839 219.706 57.3643L219.781 58.3083C219.898 59.6911 219.895 61.0823 219.767 62.4651L219.711 63.0593C219.65 63.7257 219.143 64.2533 218.499 64.3588V67.6436H218.864C219.065 67.6436 219.229 67.8075 219.229 68.0074V68.3711C219.229 68.5711 219.065 68.7349 218.864 68.7349H218.499V70.5481H218.864C219.065 70.5481 219.229 70.7119 219.229 70.9118V71.6365C219.229 71.8365 219.065 72.0003 218.864 72.0003H218.499V74.902H218.864C219.065 74.902 219.229 75.0658 219.229 75.2657V75.9904C219.229 76.1903 219.065 76.3542 218.864 76.3542H218.499V76.7179H218.864C219.065 76.7179 219.229 76.8817 219.229 77.0817V77.8064C219.229 78.0063 219.065 78.1701 218.864 78.1701H218.499V78.8949H219.226C219.427 78.8949 219.591 79.0587 219.591 79.2586V81.7993C219.591 81.9992 219.427 82.163 219.226 82.163H218.861V89.7823C219.062 89.7823 219.226 89.9462 219.226 90.1461V90.8708C219.226 91.0707 219.062 91.2346 218.861 91.2346V91.9593C219.062 91.9593 219.226 92.1231 219.226 92.323V93.0478C219.226 93.2477 219.062 93.4115 218.861 93.4115V101.756H219.589C219.789 101.756 219.954 101.919 219.954 102.119V105.907H222.708C223.106 105.907 223.435 106.232 223.435 106.631V107.195H230.892V104.921C230.892 104.704 230.719 104.529 230.502 104.529C230.284 104.529 230.109 104.355 230.109 104.138V102.758C230.109 102.441 229.849 102.183 229.529 102.183C229.13 102.183 228.849 101.78 228.991 101.406L232.444 92.3314C232.55 92.0481 232.818 91.8621 233.125 91.8621H276.157C276.416 91.8621 276.653 91.9954 276.784 92.2175L282.239 101.411C282.44 101.753 282.197 102.183 281.796 102.183C281.517 102.183 281.283 102.411 281.283 102.694V103.802C281.283 104.202 280.96 104.527 280.556 104.527H280.444C280.046 104.527 279.717 104.852 279.717 105.251V107.19H284.503V89.6824C284.503 89.5019 284.65 89.3547 284.832 89.3547C285.013 89.3547 285.163 89.2076 285.163 89.0271V82.5212C285.163 82.1214 285.487 81.7965 285.891 81.7965H297.899V81.0718C297.899 80.672 298.225 80.3471 298.627 80.3471H301.913C302.234 80.3471 302.518 80.1388 302.61 79.8334L304.299 74.33C304.391 74.0245 304.675 73.8163 304.996 73.8163H346.158C346.557 73.8163 346.886 74.1411 346.886 74.541V107.192V145.528H165.501V107.115V93.0144C165.501 92.8645 165.549 92.7173 165.635 92.5951L172.729 82.5684C172.801 82.4657 172.896 82.388 172.999 82.338V82.0797H194.493C194.814 82.0797 195.098 82.288 195.19 82.5934L196.879 88.0969C196.971 88.4023 197.256 88.6106 197.576 88.6106H200.863C201.261 88.6106 201.59 88.9354 201.59 89.3353V107.112H208.146V106.548C208.146 106.148 208.472 105.823 208.874 105.823H214.883V102.036C214.883 101.836 215.048 101.672 215.249 101.672H215.976V93.3282C215.775 93.3282 215.611 93.1644 215.611 92.9644V92.2397C215.611 92.0398 215.775 91.876 215.976 91.876V91.1513C215.775 91.1513 215.611 90.9874 215.611 90.7875V90.0628C215.611 89.8629 215.775 89.699 215.976 89.699V82.0797H215.611C215.41 82.0797 215.246 81.9159 215.246 81.716V79.1753C215.246 78.9754 215.41 78.8116 215.611 78.8116H216.338V78.0868H215.973C215.773 78.0868 215.608 77.923 215.608 77.7231V76.9984C215.608 76.7984 215.773 76.6346 215.973 76.6346H216.338V76.2709H215.973C215.773 76.2709 215.608 76.107 215.608 75.9071V75.1824C215.608 74.9825 215.773 74.8186 215.973 74.8186H216.338V71.917H215.973C215.773 71.917 215.608 71.7532 215.608 71.5532V70.8285C215.608 70.6286 215.773 70.4648 215.973 70.4648H216.338V68.6516H215.973C215.773 68.6516 215.608 68.4878 215.608 68.2878V67.9241C215.608 67.7242 215.773 67.5603 215.973 67.5603H216.338V64.2921C215.706 64.2561 215.176 63.7785 215.09 63.1426C214.831 61.2544 214.819 59.3441 215.056 57.4559L215.084 57.2115C215.134 56.8284 215.327 56.4979 215.608 56.2702V54.8569C215.608 54.657 215.773 54.4931 215.973 54.4931H216.338V50.864Z",
    fill: "url(#paint2_linear_319_33025)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.338 50.864C216.338 50.6641 216.503 50.5002 216.704 50.5002L217.239 20.3061L217.222 19.7482L217.25 19.6621L217.239 20.3061L218.134 50.5863C218.334 50.5863 218.499 50.7501 218.499 50.9501V54.5792H218.864C219.065 54.5792 219.229 54.743 219.229 54.943V56.4063C219.494 56.6479 219.672 56.9839 219.706 57.3643L219.781 58.3083C219.898 59.6911 219.895 61.0823 219.767 62.4651L219.711 63.0593C219.65 63.7257 219.143 64.2533 218.499 64.3588V67.6436H218.864C219.065 67.6436 219.229 67.8075 219.229 68.0074V68.3711C219.229 68.5711 219.065 68.7349 218.864 68.7349H218.499V70.5481H218.864C219.065 70.5481 219.229 70.7119 219.229 70.9118V71.6365C219.229 71.8365 219.065 72.0003 218.864 72.0003H218.499V74.902H218.864C219.065 74.902 219.229 75.0658 219.229 75.2657V75.9904C219.229 76.1903 219.065 76.3542 218.864 76.3542H218.499V76.7179H218.864C219.065 76.7179 219.229 76.8817 219.229 77.0817V77.8064C219.229 78.0063 219.065 78.1701 218.864 78.1701H218.499V78.8949H219.226C219.427 78.8949 219.591 79.0587 219.591 79.2586V81.7993C219.591 81.9992 219.427 82.163 219.226 82.163H218.861V89.7823C219.062 89.7823 219.226 89.9462 219.226 90.1461V90.8708C219.226 91.0707 219.062 91.2346 218.861 91.2346V91.9593C219.062 91.9593 219.226 92.1231 219.226 92.323V93.0478C219.226 93.2477 219.062 93.4115 218.861 93.4115V101.756H219.589C219.789 101.756 219.954 101.919 219.954 102.119V105.907H222.708C223.106 105.907 223.435 106.232 223.435 106.631V107.195H230.892V104.921C230.892 104.704 230.719 104.529 230.502 104.529C230.284 104.529 230.109 104.355 230.109 104.138V102.758C230.109 102.441 229.849 102.183 229.529 102.183C229.13 102.183 228.849 101.78 228.991 101.406L232.444 92.3314C232.55 92.0481 232.818 91.8621 233.125 91.8621H276.157C276.416 91.8621 276.653 91.9954 276.784 92.2175L282.239 101.411C282.44 101.753 282.197 102.183 281.796 102.183C281.517 102.183 281.283 102.411 281.283 102.694V103.802C281.283 104.202 280.96 104.527 280.556 104.527H280.444C280.046 104.527 279.717 104.852 279.717 105.251V107.19H284.503V89.6824C284.503 89.5019 284.65 89.3547 284.832 89.3547C285.013 89.3547 285.163 89.2076 285.163 89.0271V82.5212C285.163 82.1214 285.487 81.7965 285.891 81.7965H297.899V81.0718C297.899 80.672 298.225 80.3471 298.627 80.3471H301.913C302.234 80.3471 302.518 80.1388 302.61 79.8334L304.299 74.33C304.391 74.0245 304.675 73.8163 304.996 73.8163H346.158C346.557 73.8163 346.886 74.1411 346.886 74.541V107.192V145.528H165.501V107.115V93.0144C165.501 92.8645 165.549 92.7173 165.635 92.5951L172.729 82.5684C172.801 82.4657 172.896 82.388 172.999 82.338V82.0797H194.493C194.814 82.0797 195.098 82.288 195.19 82.5934L196.879 88.0969C196.971 88.4023 197.256 88.6106 197.576 88.6106H200.863C201.261 88.6106 201.59 88.9354 201.59 89.3353V107.112H208.146V106.548C208.146 106.148 208.472 105.823 208.874 105.823H214.883V102.036C214.883 101.836 215.048 101.672 215.249 101.672H215.976V93.3282C215.775 93.3282 215.611 93.1644 215.611 92.9644V92.2397C215.611 92.0398 215.775 91.876 215.976 91.876V91.1513C215.775 91.1513 215.611 90.9874 215.611 90.7875V90.0628C215.611 89.8629 215.775 89.699 215.976 89.699V82.0797H215.611C215.41 82.0797 215.246 81.9159 215.246 81.716V79.1753C215.246 78.9754 215.41 78.8116 215.611 78.8116H216.338V78.0868H215.973C215.773 78.0868 215.608 77.923 215.608 77.7231V76.9984C215.608 76.7984 215.773 76.6346 215.973 76.6346H216.338V76.2709H215.973C215.773 76.2709 215.608 76.107 215.608 75.9071V75.1824C215.608 74.9825 215.773 74.8186 215.973 74.8186H216.338V71.917H215.973C215.773 71.917 215.608 71.7532 215.608 71.5532V70.8285C215.608 70.6286 215.773 70.4648 215.973 70.4648H216.338V68.6516H215.973C215.773 68.6516 215.608 68.4878 215.608 68.2878V67.9241C215.608 67.7242 215.773 67.5603 215.973 67.5603H216.338V64.2921C215.706 64.2561 215.176 63.7785 215.09 63.1426C214.831 61.2544 214.819 59.3441 215.056 57.4559L215.084 57.2115C215.134 56.8284 215.327 56.4979 215.608 56.2702V54.8569C215.608 54.657 215.773 54.4931 215.973 54.4931H216.338V50.864Z",
    fill: "url(#paint3_linear_319_33025)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.357 106.786H292.111V127.132H283.357V106.786Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.12 106.311H292.348V106.548H283.12V106.311Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.416 106.786H292.052V107.733H283.416V106.786Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.416 118.377H292.052V119.324H283.416V118.377Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.558 106.786H291.165V116.959H287.558V106.786Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.089 124.055H291.165V127.131H288.089V124.055Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.302 124.055H287.379V127.131H284.302V124.055Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.302 125.239H285.959V127.132H284.302V125.239Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.923 120.033H291.165V120.743H289.923V120.033Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.148 120.033H289.391V120.743H288.148V120.033Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.302 120.033H287.379V122.635H284.302V120.033Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.487 120.033H287.379V122.635H285.487V120.033Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.305 120.033H285.487V122.635H284.305V120.033Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.558 108.205H291.165V110.572H287.558V108.205Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.558 111.518H291.165V113.884H287.558V111.518Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.558 114.591H291.165V116.958H287.558V114.591Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.616 108.205H288.326V110.572H287.616V108.205Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.616 111.518H288.326V113.884H287.616V111.518Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.616 114.591H288.326V116.958H287.616V114.591Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.416 117.432H292.052V117.669H283.416V117.432Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.304 108.205H285.842V110.572H284.304V108.205Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.304 111.518H285.841V113.884H284.304V111.518Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.304 114.591H285.841V116.958H284.304V114.591Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.304 108.205H284.776V110.572H284.304V108.205Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.304 111.518H284.776V113.884H284.304V111.518Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.304 114.591H284.776V116.958H284.304V114.591Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.74 108.205H290.278V110.572H288.74V108.205Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.74 111.518H290.278V113.884H288.74V111.518Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.74 114.591H290.278V116.958H288.74V114.591Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.106 109.721H246.35V127.465H202.106V109.721Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.106 122.024H246.35V127.466H202.106V122.024Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.273 113.271H244.22V115.637H243.273V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.807 111.021H247.653V111.731H200.807V111.021Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.273 118.239H244.22V120.606H243.273V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.037 123.208H245.404V127.467H243.037V123.208Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.36 123.208H240.909V127.467H237.36V123.208Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.155 123.208H235.704V127.467H232.155V123.208Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.949 123.208H230.498V127.467H226.949V123.208Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.767 124.034C225.767 123.185 225.079 122.497 224.229 122.497C223.38 122.497 222.692 123.185 222.692 124.034V127.466H225.768V124.034H225.767Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.958 123.208H221.508V127.467H217.958V123.208Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.754 123.208H216.303V127.467H212.754V123.208Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.313 123.208H210.862V127.467H207.313V123.208Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.291 123.208H205.42V127.467H203.291V123.208Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.037 123.918H245.404V127.467H243.037V123.918Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.36 123.918H240.909V127.467H237.36V123.918Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.155 123.918H235.704V127.467H232.155V123.918Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.949 123.918H230.498V127.467H226.949V123.918Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.767 124.745C225.767 123.896 225.079 123.208 224.229 123.208C223.38 123.208 222.692 123.896 222.692 124.745V127.467H225.769V124.745H225.767Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.958 123.918H221.508V127.467H217.958V123.918Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.754 123.918H216.303V127.467H212.754V123.918Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.313 123.918H210.862V127.467H207.313V123.918Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.291 123.918H205.42V127.467H203.291V123.918Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.252 113.271H240.199V115.637H239.252V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.251 118.239H240.198V120.606H239.251V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.65 113.271H237.597V115.637H236.65V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.65 118.239H237.597V120.606H236.65V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.047 113.271H234.995V115.637H234.047V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.048 118.239H234.995V120.606H234.048V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.681 113.271H232.628V115.637H231.681V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.681 118.239H232.628V120.606H231.681V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.841 113.271H229.788V115.637H228.841V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.841 118.239H229.788V120.606H228.841V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.476 113.271H227.423V115.637H226.476V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.476 118.239H227.423V120.606H226.476V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.637 113.271H224.584V115.637H223.637V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.637 118.239H224.584V120.606H223.637V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.798 113.271H221.745V115.637H220.798V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.798 118.239H221.745V120.606H220.798V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.195 113.271H219.142V115.637H218.195V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.195 118.239H219.142V120.606H218.195V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.829 113.271H216.776V115.637H215.829V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.829 118.239H216.776V120.606H215.829V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.991 113.271H213.938V115.637H212.991V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.991 118.239H213.938V120.606H212.991V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.387 113.271H211.334V115.637H210.387V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.387 118.239H211.334V120.606H210.387V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.022 113.271H208.969V115.637H208.022V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.022 118.239H208.969V120.606H208.022V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.236 113.271H205.183V115.637H204.236V113.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.236 118.239H205.183V120.606H204.236V118.239Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.398 109.721H247.06V111.14H201.398V109.721Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.328 110.194H246.35V110.667H242.328V110.194Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.652 110.194H240.673V110.667H236.652V110.194Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.973 110.194H234.995V110.667H230.973V110.194Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.294 110.194H229.315V110.667H225.294V110.194Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.615 110.194H223.637V110.667H219.615V110.194Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.938 110.194H217.96V110.667H213.938V110.194Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.259 110.194H212.281V110.667H208.259V110.194Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.581 110.194H206.603V110.667H202.581V110.194Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.598 108.657L222.829 108.704L222.791 108.894H222.598V108.657ZM221.627 108.657H221.39V108.42H221.627V108.657ZM221.627 109.84V110.077H221.39V109.84H221.627ZM226.359 109.84H226.596V110.077H226.359V109.84ZM226.359 108.657V108.42H226.596V108.657H226.359ZM225.388 108.657V108.894H225.194L225.156 108.704L225.388 108.657ZM222.598 108.894H221.627V108.422H222.598V108.894ZM221.863 108.657V109.84H221.39V108.657H221.863ZM221.627 109.602H226.359V110.075H221.627V109.602ZM226.122 109.84V108.657H226.594V109.84H226.122ZM226.359 108.894H225.388V108.422H226.359V108.894ZM225.156 108.704C225.069 108.273 224.686 107.947 224.229 107.947V107.475C224.916 107.475 225.488 107.962 225.62 108.61L225.156 108.704ZM224.229 107.947H223.757V107.475H224.229V107.947ZM223.757 107.947C223.3 107.947 222.916 108.273 222.829 108.704L222.366 108.61C222.498 107.962 223.07 107.475 223.757 107.475V107.947Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.597 108.657H221.627V109.839H226.359V108.657H225.388C225.279 108.117 224.801 107.71 224.229 107.71H223.756C223.184 107.71 222.706 108.116 222.597 108.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.322 116.245H208.485V127.128H189.322V116.245Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.322 123.343H208.485V127.127H189.322V123.343Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.227 124.764H205.884V127.13H204.227V124.764Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.15 124.764H202.807V127.13H201.15V124.764Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.601 124.764H199.258V127.13H197.601V124.764Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.526 124.764H196.183V127.13H194.526V124.764Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.214 124.764H192.871V127.13H191.214V124.764Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.227 118.611H205.884V122.161H204.227V118.611Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.15 118.611H202.807V122.161H201.15V118.611Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.601 118.611H199.258V122.161H197.601V118.611Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.526 118.611H196.183V122.161H194.526V118.611Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.578 121.925H204.698V123.344H193.578V121.925Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.214 118.611H192.871V122.161H191.214V118.611Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.903 111.529L208.113 116.246H189.691L198.901 111.529H198.903Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.196 116.957L209.788 116.365L198.787 110.568L188.141 116.365L188.614 116.957L198.787 111.515L209.198 116.957H209.196Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.35 124.331H203.872V125.119H206.238V124.331H205.76C205.722 123.976 205.42 123.701 205.056 123.701C204.692 123.701 204.39 123.976 204.352 124.331H204.35Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.35 124.33L204.583 124.355L204.56 124.566H204.35V124.328V124.33ZM203.872 124.33H203.635V124.093H203.872V124.33ZM203.872 125.118V125.355H203.635V125.118H203.872ZM206.238 125.118H206.476V125.355H206.238V125.118ZM206.238 124.33V124.093H206.476V124.33H206.238ZM205.76 124.33V124.567H205.55L205.527 124.357L205.76 124.332V124.33ZM204.35 124.567H203.872V124.095H204.35V124.567ZM204.109 124.33V125.118H203.636V124.33H204.109ZM203.872 124.882H206.238V125.355H203.872V124.882ZM206.001 125.118V124.33H206.474V125.118H206.001ZM206.238 124.567H205.76V124.095H206.238V124.567ZM205.525 124.355C205.5 124.118 205.299 123.935 205.054 123.935V123.463C205.541 123.463 205.941 123.83 205.996 124.305L205.525 124.357V124.355ZM205.054 123.935C204.81 123.935 204.609 124.12 204.583 124.355L204.113 124.303C204.167 123.83 204.567 123.461 205.054 123.461V123.934V123.935Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.273 124.331H200.795V125.119H203.162V124.331H202.684C202.646 123.976 202.343 123.701 201.979 123.701C201.615 123.701 201.313 123.976 201.275 124.331H201.273Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.273 124.33L201.507 124.355L201.483 124.566H201.273V124.328V124.33ZM200.795 124.33H200.558V124.093H200.795V124.33ZM200.795 125.118V125.355H200.558V125.118H200.795ZM203.162 125.118H203.399V125.355H203.162V125.118ZM203.162 124.33V124.093H203.399V124.33H203.162ZM202.684 124.33V124.567H202.474L202.45 124.357L202.684 124.332V124.33ZM201.273 124.567H200.795V124.095H201.273V124.567ZM201.033 124.33V125.118H200.56V124.33H201.033ZM200.795 124.882H203.162V125.355H200.795V124.882ZM202.925 125.118V124.33H203.397V125.118H202.925ZM203.162 124.567H202.684V124.095H203.162V124.567ZM202.45 124.355C202.425 124.118 202.224 123.935 201.98 123.935V123.463C202.467 123.463 202.867 123.83 202.921 124.305L202.45 124.357V124.355ZM201.98 123.935C201.735 123.935 201.534 124.12 201.509 124.355L201.038 124.303C201.092 123.83 201.492 123.461 201.98 123.461V123.934V123.935Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.726 124.331H197.248V125.119H199.615V124.331H199.136C199.098 123.976 198.796 123.701 198.432 123.701C198.068 123.701 197.766 123.976 197.728 124.331H197.726Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.726 124.33L197.96 124.355L197.936 124.566H197.726V124.328V124.33ZM197.248 124.33H197.011V124.093H197.248V124.33ZM197.248 125.118V125.355H197.011V125.118H197.248ZM199.613 125.118H199.85V125.355H199.613V125.118ZM199.613 124.33V124.093H199.85V124.33H199.613ZM199.135 124.33V124.567H198.925L198.901 124.357L199.135 124.332V124.33ZM197.726 124.567H197.248V124.095H197.726V124.567ZM197.483 124.33V125.118H197.011V124.33H197.483ZM197.248 124.882H199.615V125.355H197.248V124.882ZM199.378 125.118V124.33H199.85V125.118H199.378ZM199.613 124.567H199.135V124.095H199.613V124.567ZM198.901 124.355C198.876 124.118 198.675 123.935 198.431 123.935V123.463C198.918 123.463 199.318 123.83 199.372 124.305L198.901 124.357V124.355ZM198.431 123.935C198.186 123.935 197.985 124.12 197.96 124.355L197.489 124.303C197.543 123.83 197.943 123.461 198.431 123.461V123.934V123.935Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.649 124.331H194.171V125.119H196.537V124.331H196.059C196.021 123.976 195.719 123.701 195.355 123.701C194.991 123.701 194.689 123.976 194.651 124.331H194.649Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.649 124.33L194.882 124.355L194.859 124.566H194.649V124.328V124.33ZM194.171 124.33H193.934V124.093H194.171V124.33ZM194.171 125.118V125.355H193.934V125.118H194.171ZM196.538 125.118H196.775V125.355H196.538V125.118ZM196.538 124.33V124.093H196.775V124.33H196.538ZM196.06 124.33V124.567H195.849L195.826 124.357L196.06 124.332V124.33ZM194.649 124.567H194.171V124.095H194.649V124.567ZM194.408 124.33V125.118H193.935V124.33H194.408ZM194.171 124.882H196.538V125.355H194.171V124.882ZM196.3 125.118V124.33H196.773V125.118H196.3ZM196.538 124.567H196.06V124.095H196.538V124.567ZM195.824 124.355C195.799 124.118 195.598 123.935 195.353 123.935V123.463C195.84 123.463 196.241 123.83 196.295 124.305L195.824 124.357V124.355ZM195.353 123.935C195.109 123.935 194.908 124.12 194.882 124.355L194.412 124.303C194.466 123.83 194.866 123.461 195.353 123.461V123.934V123.935Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.337 124.331H190.859V125.119H193.226V124.331H192.748C192.71 123.976 192.407 123.701 192.043 123.701C191.679 123.701 191.377 123.976 191.339 124.331H191.337Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.337 124.33L191.571 124.355L191.547 124.566H191.337V124.328V124.33ZM190.859 124.33H190.622V124.093H190.859V124.33ZM190.859 125.118V125.355H190.622V125.118H190.859ZM193.224 125.118H193.461V125.355H193.224V125.118ZM193.224 124.33V124.093H193.461V124.33H193.224ZM192.748 124.33V124.567H192.538L192.514 124.357L192.748 124.332V124.33ZM191.337 124.567H190.859V124.095H191.337V124.567ZM191.096 124.33V125.118H190.624V124.33H191.096ZM190.859 124.882H193.226V125.355H190.859V124.882ZM192.989 125.118V124.33H193.461V125.118H192.989ZM193.224 124.567H192.746V124.095H193.224V124.567ZM192.513 124.355C192.487 124.118 192.286 123.935 192.042 123.935V123.463C192.529 123.463 192.929 123.83 192.983 124.305L192.513 124.357V124.355ZM192.042 123.935C191.797 123.935 191.596 124.12 191.571 124.355L191.1 124.303C191.154 123.83 191.555 123.461 192.042 123.461V123.934V123.935Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.989 117.547C203.989 117.569 204.002 117.603 204.045 117.645C204.091 117.689 204.161 117.732 204.261 117.772C204.456 117.852 204.739 117.902 205.054 117.902C205.369 117.902 205.65 117.852 205.847 117.772C205.947 117.732 206.017 117.689 206.063 117.645C206.108 117.602 206.119 117.569 206.119 117.547C206.119 117.526 206.106 117.491 206.063 117.45C206.017 117.406 205.947 117.363 205.847 117.323C205.651 117.243 205.369 117.192 205.054 117.192C204.739 117.192 204.458 117.243 204.261 117.323C204.161 117.363 204.091 117.406 204.045 117.45C204 117.493 203.989 117.526 203.989 117.547Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.914 117.547C200.914 117.569 200.927 117.603 200.97 117.645C201.015 117.689 201.086 117.732 201.186 117.772C201.381 117.852 201.664 117.902 201.979 117.902C202.294 117.902 202.574 117.852 202.772 117.772C202.871 117.732 202.942 117.689 202.987 117.645C203.033 117.602 203.043 117.569 203.043 117.547C203.043 117.526 203.031 117.491 202.987 117.45C202.942 117.406 202.871 117.363 202.772 117.323C202.576 117.243 202.294 117.192 201.979 117.192C201.664 117.192 201.383 117.243 201.186 117.323C201.086 117.363 201.015 117.406 200.97 117.45C200.925 117.493 200.914 117.526 200.914 117.547Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.365 117.547C197.365 117.569 197.378 117.603 197.421 117.645C197.467 117.689 197.537 117.732 197.637 117.772C197.832 117.852 198.115 117.902 198.43 117.902C198.745 117.902 199.026 117.852 199.223 117.772C199.323 117.732 199.393 117.689 199.439 117.645C199.484 117.602 199.495 117.569 199.495 117.547C199.495 117.526 199.482 117.491 199.439 117.45C199.393 117.406 199.323 117.363 199.223 117.323C199.028 117.243 198.745 117.192 198.43 117.192C198.115 117.192 197.834 117.243 197.637 117.323C197.537 117.363 197.467 117.406 197.421 117.45C197.376 117.493 197.365 117.526 197.365 117.547Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.289 117.547C194.289 117.569 194.301 117.603 194.345 117.645C194.39 117.689 194.461 117.732 194.56 117.772C194.756 117.852 195.038 117.902 195.353 117.902C195.669 117.902 195.949 117.852 196.147 117.772C196.246 117.732 196.317 117.689 196.362 117.645C196.407 117.602 196.418 117.569 196.418 117.547C196.418 117.526 196.406 117.491 196.362 117.45C196.317 117.406 196.246 117.363 196.147 117.323C195.951 117.243 195.669 117.192 195.353 117.192C195.038 117.192 194.758 117.243 194.56 117.323C194.461 117.363 194.39 117.406 194.345 117.45C194.3 117.493 194.289 117.526 194.289 117.547Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.977 117.547C190.977 117.569 190.99 117.603 191.033 117.645C191.078 117.689 191.149 117.732 191.249 117.772C191.444 117.852 191.727 117.902 192.042 117.902C192.357 117.902 192.637 117.852 192.835 117.772C192.934 117.732 193.005 117.689 193.05 117.645C193.096 117.602 193.106 117.569 193.106 117.547C193.106 117.526 193.094 117.491 193.05 117.45C193.005 117.406 192.934 117.363 192.835 117.323C192.639 117.243 192.357 117.192 192.042 117.192C191.727 117.192 191.446 117.243 191.249 117.323C191.149 117.363 191.078 117.406 191.033 117.45C190.988 117.493 190.977 117.526 190.977 117.547Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.785 113.052L201.979 114.589H195.828L198.785 113.052Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.928 127.834L139.781 129.074C137.812 129.292 135.925 128.237 135.082 126.445L134.532 125.278C134.348 124.886 134.264 124.456 134.286 124.025L134.348 122.865C134.473 120.447 137.747 119.802 138.779 121.991L139.352 120.132C140.098 117.706 143.524 117.691 144.293 120.111C144.602 116.66 149.14 115.612 150.93 118.579L151.396 117.842C152.668 115.831 155.424 115.405 157.245 116.938C158.811 118.258 159.098 120.563 157.905 122.228L156.691 123.919C158.373 124.435 158.168 126.876 156.427 127.105L150.93 127.832L150.928 127.834Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.186447
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.486 127.834L140.537 129.029C138.58 129.264 136.685 128.231 135.824 126.456L135.44 125.664C135.265 125.304 135.181 124.907 135.201 124.508L135.246 123.561C135.349 121.336 138.35 120.717 139.324 122.718L139.821 121.103C140.506 118.87 143.657 118.838 144.386 121.057C144.65 117.921 148.762 116.934 150.423 119.608L150.488 119.716L150.9 119.073C152.071 117.248 154.573 116.858 156.246 118.239C157.715 119.455 157.985 121.607 156.863 123.149L155.828 124.569C157.291 125.019 157.083 127.154 155.559 127.31L150.49 127.832L150.486 127.834Z",
    fill: "#63B19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.759 127.671L180.583 124.603C182.473 123.607 183.62 121.615 183.533 119.482L183.448 117.487C183.428 116.971 183.279 116.47 183.014 116.024L182.311 114.831C180.839 112.342 177.019 113.468 177.137 116.358L175.505 114.709C173.372 112.553 169.736 114.435 170.264 117.42C168.03 113.938 162.645 115.341 162.391 119.471L161.492 118.95C159.031 117.525 155.881 118.598 154.801 121.227C153.873 123.492 154.846 126.09 157.03 127.19L159.247 128.31H172.183C173.082 128.31 173.966 128.091 174.761 127.673L174.759 127.671Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.222641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.277 127.671L280.101 124.603C281.992 123.607 283.138 121.615 283.051 119.482L282.967 117.487C282.947 116.971 282.798 116.47 282.533 116.024L281.829 114.831C280.357 112.342 276.537 113.468 276.655 116.358L275.023 114.709C272.89 112.553 269.254 114.435 269.782 117.42C267.549 113.938 262.163 115.341 261.909 119.471L261.01 118.95C258.55 117.525 255.399 118.598 254.32 121.227C253.391 123.492 254.364 126.09 256.548 127.19L258.766 128.31H271.701C272.601 128.31 273.485 128.091 274.279 127.673L274.277 127.671Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.222641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.824 126.621L180.706 125.107C182.055 124.023 182.819 122.369 182.767 120.639L182.701 118.399C182.69 117.922 182.556 117.457 182.313 117.045L181.743 116.068C180.405 113.772 176.888 114.774 176.961 117.43L175.545 115.997C173.583 114.013 170.233 115.72 170.687 118.475C168.672 115.302 163.776 116.531 163.498 120.28L163.487 120.432L162.692 119.98C160.445 118.695 157.58 119.668 156.578 122.055C155.697 124.154 156.598 126.579 158.64 127.592L160.521 128.522H170.685L176.093 127.797C177.09 127.663 178.036 127.258 178.822 126.625L178.824 126.621Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.343 126.621L280.224 125.107C281.573 124.023 282.337 122.369 282.286 120.639L282.219 118.399C282.208 117.922 282.074 117.457 281.832 117.045L281.262 116.068C279.924 113.772 276.406 114.774 276.479 117.43L275.063 115.997C273.102 114.013 269.751 115.72 270.205 118.475C268.19 115.302 263.295 116.531 263.016 120.28L263.005 120.432L262.21 119.98C259.964 118.695 257.098 119.668 256.097 122.055C255.215 124.154 256.117 126.579 258.158 127.592L260.039 128.522H270.203L275.611 127.797C276.608 127.663 277.555 127.258 278.341 126.625L278.343 126.621Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.749 123.763C201.94 122.912 201.778 121.634 202.352 120.609L205.608 114.78C205.925 114.213 206.74 114.213 207.057 114.78L210.407 120.781C210.93 121.715 210.816 122.878 210.123 123.694C209.636 124.268 208.92 124.598 208.165 124.598H204.694C203.959 124.598 203.256 124.295 202.749 123.763Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.944 123.882C202.164 123.154 202.01 121.973 202.577 121.07L205.293 116.762C205.662 116.173 206.523 116.173 206.892 116.762L209.994 121.683C210.341 122.238 210.269 122.958 209.816 123.433C209.174 124.103 208.286 124.481 207.357 124.481H204.458C203.895 124.481 203.354 124.268 202.941 123.884L202.944 123.882Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.331 118.564V127.318",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.105 119.277L206.448 120.934",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.556 121.167L206.213 122.824",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.794 119.277L206.451 120.934",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.369 127.186C196.268 126.195 196.426 124.428 197.681 123.646L199.765 122.349C200.087 122.15 200.496 122.157 200.808 122.371L202.659 123.633C203.856 124.452 204.015 126.156 202.99 127.18C202.975 127.193 202.959 127.2 202.941 127.2H197.409C197.395 127.2 197.38 127.195 197.369 127.184V127.186Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.369 127.184C197.38 127.195 197.395 127.2 197.409 127.2H202.941C202.959 127.2 202.975 127.193 202.99 127.18C204.015 126.156 203.856 124.452 202.659 123.633L200.808 122.371C200.496 122.157 200.087 122.15 199.765 122.349L197.681 123.646C196.426 124.428 196.268 126.195 197.369 127.186V127.184ZM197.369 127.184L197.29 127.273",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.061 127.032C196.342 126.168 196.574 124.864 197.546 124.299L199.879 122.947C200.136 122.798 200.456 122.802 200.71 122.956L202.309 123.932C203.446 124.625 203.527 126.246 202.464 127.05C202.441 127.07 202.41 127.079 202.378 127.079H197.17C197.126 127.079 197.09 127.061 197.061 127.028V127.032Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.942 125.189V127.082",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.48 124.716L199.942 126.135",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.76 125.427L199.942 126.729",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3248 128.16L24.1771 129.4C22.2083 129.618 20.3214 128.563 19.4787 126.771L18.9287 125.604C18.7441 125.212 18.6602 124.782 18.6826 124.351L18.7441 123.191C18.869 120.773 22.143 120.128 23.1759 122.317L23.7483 120.458C24.4941 118.032 27.921 118.018 28.6891 120.438C28.9986 116.986 33.5368 115.939 35.3267 118.905L35.7928 118.169C37.0644 116.157 39.82 115.732 41.6416 117.264C43.2077 118.584 43.4949 120.889 42.3016 122.554L41.0879 124.245C42.7696 124.761 42.5645 127.202 40.8231 127.431L35.3267 128.158L35.3248 128.16Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.186447
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8824 128.16L24.9336 129.355C22.9759 129.59 21.0816 128.557 20.2202 126.782L19.8361 125.99C19.6609 125.63 19.577 125.233 19.5975 124.834L19.6422 123.887C19.7448 121.663 22.7466 121.044 23.7198 123.044L24.2176 121.429C24.9019 119.196 28.0529 119.164 28.7819 121.383C29.0466 118.247 33.1578 117.261 34.819 119.934L34.8843 120.042L35.2963 119.399C36.4672 117.574 38.9693 117.184 40.6418 118.566C42.111 119.781 42.3813 121.933 41.2589 123.475L40.2241 124.896C41.6877 125.345 41.4789 127.48 39.9556 127.636L34.8861 128.158L34.8824 128.16Z",
    fill: "#63B19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1556 127.994L64.9798 124.926C66.8701 123.931 68.0167 121.938 67.9298 119.805L67.8452 117.81C67.8252 117.294 67.676 116.793 67.4111 116.348L66.7075 115.154C65.2359 112.665 61.4154 113.792 61.5334 116.682L59.9014 115.032C57.7685 112.877 54.1328 114.758 54.6604 117.744C52.4273 114.261 47.0417 115.664 46.7879 119.794L45.8884 119.273C43.4282 117.848 40.2778 118.921 39.198 121.551C38.2696 123.815 39.2425 126.413 41.4267 127.513L43.6442 128.633H56.5796C57.4791 128.633 58.3629 128.415 59.1578 127.996L59.1556 127.994Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.222641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.674 127.994L164.498 124.926C166.389 123.931 167.535 121.938 167.448 119.805L167.364 117.81C167.344 117.294 167.194 116.793 166.93 116.348L166.226 115.154C164.754 112.665 160.934 113.792 161.052 116.682L159.42 115.032C157.287 112.877 153.651 114.758 154.179 117.744C151.946 114.261 146.56 115.664 146.306 119.794L145.407 119.273C142.947 117.848 139.796 118.921 138.716 121.551C137.788 123.815 138.761 126.413 140.945 127.513L143.163 128.633H156.098C156.998 128.633 157.881 128.415 158.676 127.996L158.674 127.994Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.222641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2213 126.944L65.1027 125.43C66.4519 124.346 67.2155 122.692 67.1643 120.962L67.0975 118.722C67.0864 118.246 66.9528 117.78 66.7101 117.368L66.1402 116.391C64.8021 114.096 61.2844 115.098 61.3578 117.754L59.9418 116.32C57.9803 114.336 54.6296 116.044 55.0838 118.798C53.0689 115.625 48.173 116.854 47.8947 120.603L47.8836 120.755L47.0888 120.303C44.8423 119.018 41.9769 119.991 40.975 122.378C40.0934 124.477 40.9951 126.902 43.0367 127.915L44.918 128.846H55.0816L60.4896 128.12C61.487 127.986 62.4332 127.581 63.2191 126.949L63.2213 126.944Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.74 126.944L164.621 125.43C165.971 124.346 166.734 122.692 166.683 120.962L166.616 118.722C166.605 118.246 166.472 117.78 166.229 117.368L165.659 116.391C164.321 114.096 160.803 115.098 160.877 117.754L159.461 116.32C157.499 114.336 154.148 116.044 154.603 118.798C152.588 115.625 147.692 116.854 147.414 120.603L147.402 120.755L146.608 120.303C144.361 119.018 141.496 119.991 140.494 122.378C139.612 124.477 140.514 126.902 142.556 127.915L144.437 128.846H154.6L160.008 128.12C161.006 127.986 161.952 127.581 162.738 126.949L162.74 126.944Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1456 124.086C86.3361 123.235 86.175 121.957 86.749 120.932L90.0048 115.103C90.3217 114.536 91.1366 114.536 91.4535 115.103L94.8035 121.104C95.3268 122.038 95.2128 123.201 94.5192 124.017C94.0321 124.591 93.3168 124.921 92.5617 124.921H89.0904C88.3552 124.921 87.6526 124.619 87.1456 124.086Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3412 124.206C86.5607 123.478 86.4068 122.297 86.9736 121.394L89.6898 117.086C90.0592 116.497 90.9194 116.497 91.2888 117.086L94.3907 122.008C94.7383 122.562 94.6659 123.283 94.2132 123.757C93.5704 124.427 92.6831 124.805 91.7542 124.805H88.855C88.2919 124.805 87.7504 124.592 87.3376 124.208L87.3412 124.206Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7273 118.89V127.643",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5021 119.601L90.8452 121.257",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.953 121.491L90.6099 123.148",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1902 119.601L90.8472 121.257",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7651 127.51C80.6641 126.52 80.8216 124.752 82.0765 123.97L84.1608 122.673C84.4831 122.474 84.8923 122.482 85.2038 122.695L87.0544 123.957C88.2514 124.776 88.4108 126.48 87.3858 127.505C87.3713 127.517 87.355 127.525 87.3369 127.525H81.8049C81.7904 127.525 81.7759 127.519 81.7651 127.508V127.51Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7651 127.508C81.7759 127.519 81.7904 127.525 81.8049 127.525H87.3369C87.355 127.525 87.3713 127.517 87.3858 127.505C88.4108 126.48 88.2514 124.776 87.0544 123.957L85.2038 122.695C84.8923 122.482 84.4831 122.474 84.1608 122.673L82.0765 123.97C80.8216 124.752 80.6641 126.52 81.7651 127.51V127.508ZM81.7651 127.508L81.6854 127.597",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4578 127.357C80.7389 126.493 80.9707 125.19 81.9431 124.625L84.2754 123.272C84.5326 123.124 84.8531 123.127 85.1066 123.281L86.7055 124.257C87.8427 124.951 87.9242 126.571 86.8613 127.375C86.8377 127.395 86.8069 127.404 86.7744 127.404H81.5665C81.523 127.404 81.4868 127.386 81.4578 127.354V127.357Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3389 125.513V127.405",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8762 125.04L84.3388 126.46",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1566 125.751L84.339 127.053",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.943 91.9775H278.277V127.466H270.943V91.9775Z",
    fill: "#E0CEAB",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.631 93.8701H270.943V127.466H267.631V93.8701Z",
    fill: "#F5D7CA",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.836 91.9775H276.385V127.466H272.836V91.9775Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.297 91.9775H267.631V127.466H260.297V91.9775Z",
    fill: "#E0CEAB",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.191 91.9775H265.74V127.466H262.191V91.9775Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.189 91.9775H263.845V127.466H262.189V91.9775Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.836 91.9775H274.493V127.466H272.836V91.9775Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.145 86.2393H275.263V92.0357H275.145V86.2393Z",
    stroke: "#615E66",
    strokeWidth: 0.0905406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.726 90.0264H273.844V92.0382H273.726V90.0264Z",
    stroke: "#615E66",
    strokeWidth: 0.0905406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.49 96.9561H223.91V109.688H201.49V96.9561Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.49 105.258H223.91V109.685H201.49V105.258Z",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.927 106.919H220.866V109.688H218.927V106.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.327 106.919H217.266V109.688H215.327V106.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.175 106.919H213.114V109.688H211.175V106.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.578 106.919H209.516V109.688H207.578V106.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.703 106.919H205.642V109.688H203.703V106.919Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.927 99.7236H220.866V103.876H218.927V99.7236Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.328 99.7236H217.266V103.876H215.328V99.7236Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.175 99.7236H213.114V103.876H211.175V99.7236Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.578 99.7236H209.516V103.876H207.578V99.7236Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.469 103.601H219.479V105.261H206.469V103.601Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.703 99.7236H205.642V103.876H203.703V99.7236Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.699 91.4375L223.473 96.9562H201.922L212.697 91.4375H212.699Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.741 97.7865L225.433 97.0938L212.564 90.3125L200.109 97.0938L200.662 97.7865L212.564 91.4205L224.743 97.7865H224.741Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.071 106.413H218.512V107.335H221.281V106.413H220.721C220.677 105.998 220.323 105.676 219.897 105.676C219.471 105.676 219.118 105.998 219.073 106.413H219.071Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.071 106.413L219.344 106.443L219.317 106.689H219.071V106.411V106.413ZM218.512 106.413H218.234V106.136H218.512V106.413ZM218.512 107.335V107.612H218.234V107.335H218.512ZM221.28 107.335H221.558V107.612H221.28V107.335ZM221.28 106.413V106.136H221.558V106.413H221.28ZM220.721 106.413V106.691H220.475L220.448 106.445L220.721 106.415V106.413ZM219.071 106.691H218.512V106.138H219.071V106.691ZM218.789 106.413V107.335H218.236V106.413H218.789ZM218.512 107.06H221.28V107.612H218.512V107.06ZM221.003 107.335V106.413H221.556V107.335H221.003ZM221.28 106.691H220.721V106.138H221.28V106.691ZM220.446 106.443C220.416 106.165 220.181 105.952 219.895 105.952V105.399C220.465 105.399 220.933 105.829 220.997 106.384L220.446 106.445V106.443ZM219.895 105.952C219.609 105.952 219.374 106.168 219.344 106.443L218.793 106.382C218.857 105.829 219.325 105.396 219.895 105.396V105.949V105.952Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.472 106.413H214.912V107.335H217.681V106.413H217.122C217.077 105.998 216.724 105.676 216.298 105.676C215.872 105.676 215.518 105.998 215.474 106.413H215.472Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.472 106.413L215.745 106.443L215.717 106.689H215.472V106.411V106.413ZM214.912 106.413H214.635V106.136H214.912V106.413ZM214.912 107.335V107.612H214.635V107.335H214.912ZM217.681 107.335H217.959V107.612H217.681V107.335ZM217.681 106.413V106.136H217.959V106.413H217.681ZM217.122 106.413V106.691H216.876L216.849 106.445L217.122 106.415V106.413ZM215.472 106.691H214.912V106.138H215.472V106.691ZM215.19 106.413V107.335H214.637V106.413H215.19ZM214.912 107.06H217.681V107.612H214.912V107.06ZM217.404 107.335V106.413H217.956V107.335H217.404ZM217.681 106.691H217.122V106.138H217.681V106.691ZM216.849 106.443C216.819 106.165 216.584 105.952 216.298 105.952V105.399C216.868 105.399 217.336 105.829 217.399 106.384L216.849 106.445V106.443ZM216.298 105.952C216.012 105.952 215.777 106.168 215.747 106.443L215.196 106.382C215.26 105.829 215.728 105.396 216.298 105.396V105.949V105.952Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.321 106.413H210.762V107.335H213.531V106.413H212.972C212.927 105.998 212.573 105.676 212.148 105.676C211.722 105.676 211.368 105.998 211.324 106.413H211.321Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.321 106.413L211.595 106.443L211.567 106.689H211.321V106.411V106.413ZM210.762 106.413H210.484V106.136H210.762V106.413ZM210.762 107.335V107.612H210.484V107.335H210.762ZM213.529 107.335H213.806V107.612H213.529V107.335ZM213.529 106.413V106.136H213.806V106.413H213.529ZM212.969 106.413V106.691H212.724L212.696 106.445L212.969 106.415V106.413ZM211.321 106.691H210.762V106.138H211.321V106.691ZM211.037 106.413V107.335H210.484V106.413H211.037ZM210.762 107.06H213.531V107.612H210.762V107.06ZM213.253 107.335V106.413H213.806V107.335H213.253ZM213.529 106.691H212.969V106.138H213.529V106.691ZM212.696 106.443C212.667 106.165 212.431 105.952 212.145 105.952V105.399C212.715 105.399 213.183 105.829 213.247 106.384L212.696 106.445V106.443ZM212.145 105.952C211.859 105.952 211.624 106.168 211.595 106.443L211.044 106.382C211.107 105.829 211.575 105.396 212.145 105.396V105.949V105.952Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.722 106.413H207.162V107.335H209.931V106.413H209.372C209.327 105.998 208.974 105.676 208.548 105.676C208.122 105.676 207.768 105.998 207.724 106.413H207.722Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.721 106.413L207.995 106.443L207.967 106.689H207.721V106.411V106.413ZM207.162 106.413H206.884V106.136H207.162V106.413ZM207.162 107.335V107.612H206.884V107.335H207.162ZM209.931 107.335H210.208V107.612H209.931V107.335ZM209.931 106.413V106.136H210.208V106.413H209.931ZM209.372 106.413V106.691H209.126L209.098 106.445L209.372 106.415V106.413ZM207.721 106.691H207.162V106.138H207.721V106.691ZM207.439 106.413V107.335H206.887V106.413H207.439ZM207.162 107.06H209.931V107.612H207.162V107.06ZM209.653 107.335V106.413H210.206V107.335H209.653ZM209.931 106.691H209.372V106.138H209.931V106.691ZM209.096 106.443C209.067 106.165 208.831 105.952 208.545 105.952V105.399C209.115 105.399 209.583 105.829 209.647 106.384L209.096 106.445V106.443ZM208.545 105.952C208.259 105.952 208.024 106.168 207.995 106.443L207.444 106.382C207.507 105.829 207.975 105.396 208.545 105.396V105.949V105.952Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.848 106.413H203.289V107.335H206.057V106.413H205.498C205.454 105.998 205.1 105.676 204.674 105.676C204.248 105.676 203.894 105.998 203.85 106.413H203.848Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.847 106.413L204.121 106.443L204.093 106.689H203.847V106.411V106.413ZM203.288 106.413H203.01V106.136H203.288V106.413ZM203.288 107.335V107.612H203.01V107.335H203.288ZM206.055 107.335H206.332V107.612H206.055V107.335ZM206.055 106.413V106.136H206.332V106.413H206.055ZM205.498 106.413V106.691H205.252L205.224 106.445L205.498 106.415V106.413ZM203.847 106.691H203.288V106.138H203.847V106.691ZM203.566 106.413V107.335H203.013V106.413H203.566ZM203.288 107.06H206.057V107.612H203.288V107.06ZM205.779 107.335V106.413H206.332V107.335H205.779ZM206.055 106.691H205.495V106.138H206.055V106.691ZM205.222 106.443C205.193 106.165 204.957 105.952 204.671 105.952V105.399C205.241 105.399 205.709 105.829 205.773 106.384L205.222 106.445V106.443ZM204.671 105.952C204.385 105.952 204.15 106.168 204.121 106.443L203.57 106.382C203.633 105.829 204.101 105.396 204.671 105.396V105.949V105.952Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.65 98.4768C218.65 98.5022 218.664 98.5424 218.715 98.5911C218.768 98.642 218.851 98.6928 218.967 98.7394C219.196 98.8327 219.527 98.892 219.895 98.892C220.264 98.892 220.592 98.8327 220.823 98.7394C220.94 98.6928 221.022 98.642 221.075 98.5911C221.128 98.5403 221.141 98.5022 221.141 98.4768C221.141 98.4513 221.126 98.4111 221.075 98.3624C221.022 98.3115 220.94 98.2607 220.823 98.2141C220.594 98.1208 220.264 98.0615 219.895 98.0615C219.527 98.0615 219.198 98.1208 218.967 98.2141C218.851 98.2607 218.768 98.3115 218.715 98.3624C218.662 98.4132 218.65 98.4513 218.65 98.4768Z",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.052 98.4768C215.052 98.5022 215.067 98.5424 215.118 98.5911C215.171 98.642 215.253 98.6928 215.37 98.7394C215.598 98.8327 215.929 98.892 216.298 98.892C216.666 98.892 216.995 98.8327 217.225 98.7394C217.342 98.6928 217.425 98.642 217.478 98.5911C217.531 98.5403 217.543 98.5022 217.543 98.4768C217.543 98.4513 217.528 98.4111 217.478 98.3624C217.425 98.3115 217.342 98.2607 217.225 98.2141C216.997 98.1208 216.666 98.0615 216.298 98.0615C215.929 98.0615 215.601 98.1208 215.37 98.2141C215.253 98.2607 215.171 98.3115 215.118 98.3624C215.065 98.4132 215.052 98.4513 215.052 98.4768Z",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.899 98.4768C210.899 98.5022 210.914 98.5424 210.965 98.5911C211.018 98.642 211.101 98.6928 211.217 98.7394C211.446 98.8327 211.776 98.892 212.145 98.892C212.514 98.892 212.842 98.8327 213.073 98.7394C213.189 98.6928 213.272 98.642 213.325 98.5911C213.378 98.5403 213.391 98.5022 213.391 98.4768C213.391 98.4513 213.376 98.4111 213.325 98.3624C213.272 98.3115 213.189 98.2607 213.073 98.2141C212.844 98.1208 212.514 98.0615 212.145 98.0615C211.776 98.0615 211.448 98.1208 211.217 98.2141C211.101 98.2607 211.018 98.3115 210.965 98.3624C210.912 98.4132 210.899 98.4513 210.899 98.4768Z",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.3 98.4768C207.3 98.5022 207.315 98.5424 207.366 98.5911C207.419 98.642 207.502 98.6928 207.618 98.7394C207.847 98.8327 208.177 98.892 208.546 98.892C208.915 98.892 209.243 98.8327 209.474 98.7394C209.59 98.6928 209.673 98.642 209.726 98.5911C209.779 98.5403 209.792 98.5022 209.792 98.4768C209.792 98.4513 209.777 98.4111 209.726 98.3624C209.673 98.3115 209.59 98.2607 209.474 98.2141C209.245 98.1208 208.915 98.0615 208.546 98.0615C208.177 98.0615 207.849 98.1208 207.618 98.2141C207.502 98.2607 207.419 98.3115 207.366 98.3624C207.313 98.4132 207.3 98.4513 207.3 98.4768Z",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.426 98.4768C203.426 98.5022 203.441 98.5424 203.492 98.5911C203.545 98.642 203.627 98.6928 203.744 98.7394C203.972 98.8327 204.303 98.892 204.672 98.892C205.04 98.892 205.369 98.8327 205.599 98.7394C205.716 98.6928 205.799 98.642 205.852 98.5911C205.905 98.5403 205.917 98.5022 205.917 98.4768C205.917 98.4513 205.902 98.4111 205.852 98.3624C205.799 98.3115 205.716 98.2607 205.599 98.2141C205.371 98.1208 205.04 98.0615 204.672 98.0615C204.303 98.0615 203.975 98.1208 203.744 98.2141C203.627 98.2607 203.545 98.3115 203.492 98.3624C203.439 98.4132 203.426 98.4513 203.426 98.4768Z",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.56 93.2197L216.297 95.0183H209.101L212.56 93.2197Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.211849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.093 104.084H285.298V127.804H275.093V104.084Z",
    fill: "#D8D1C3",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.815 103.529H285.573V103.806H274.815V103.529Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.161 104.084H285.229V105.188H275.161V104.084Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.161 117.598H285.229V118.702H275.161V117.598Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.99 104.084H284.195V115.944H279.99V104.084Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.608 125.596H284.195V127.802H280.608V125.596Z",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.608 125.596H282.54V127.802H280.608V125.596Z",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.333 125.596H279.92V127.802H276.333V125.596Z",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.195 125.596H278.127V127.802H276.195V125.596Z",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.747 119.527H284.195V120.355H282.747V119.527Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.677 119.527H282.125V120.355H280.677V119.527Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.196 119.527H279.713V121.182H276.196V119.527Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.264 119.527H279.713V120.355H278.264V119.527Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.195 119.527H277.643V120.355H276.195V119.527Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.989 105.737H284.195V108.497H279.989V105.737Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.989 109.599H284.195V112.358H279.989V109.599Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.99 113.184H284.195V115.943H279.99V113.184Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.057 105.737H280.885V108.497H280.057V105.737Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.057 109.599H280.885V112.358H280.057V109.599Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.057 113.184H280.885V115.943H280.057V113.184Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.161 116.493H285.229V116.77H275.161V116.493Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.195 105.737H277.987V108.497H276.195V105.737Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.195 109.599H277.987V112.358H276.195V109.599Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.195 113.184H277.987V115.943H276.195V113.184Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.195 105.737H276.746V108.497H276.195V105.737Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.195 109.599H276.746V112.358H276.195V109.599Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.195 113.184H276.746V115.943H276.195V113.184Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.368 105.737H283.16V108.497H281.368V105.737Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.368 109.599H283.16V112.358H281.368V109.599Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.368 113.184H283.16V115.943H281.368V113.184Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.21111
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.182 122.288C306.5 122.288 295.408 111.196 295.408 97.5142C295.408 83.8321 306.5 72.7402 320.182 72.7402C333.864 72.7402 344.956 83.8321 344.956 97.5142C344.956 111.196 333.864 122.288 320.182 122.288ZM320.182 120.191C307.658 120.191 297.505 110.039 297.505 97.5142C297.505 84.9898 307.658 74.837 320.182 74.837C332.707 74.837 342.859 84.9898 342.859 97.5142C342.859 110.039 332.707 120.191 320.182 120.191Z",
    fill: "#F2C2AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.182 110.755C312.87 110.755 306.943 104.886 306.943 97.6464C306.943 90.407 312.87 84.5381 320.182 84.5381C327.493 84.5381 333.421 90.407 333.421 97.6464C333.421 104.886 327.493 110.755 320.182 110.755ZM320.182 108.921C313.884 108.921 308.777 103.875 308.777 97.6484C308.777 91.4223 313.884 86.376 320.182 86.376C326.48 86.376 331.587 91.4223 331.587 97.6484C331.587 103.875 326.48 108.921 320.182 108.921Z",
    fill: "#F2C2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.182 122.288C306.5 122.288 295.408 111.197 295.408 97.5142C295.408 83.8319 306.5 72.7402 320.182 72.7402C333.864 72.7402 344.956 83.8319 344.956 97.5142C344.956 111.197 333.864 122.288 320.182 122.288Z",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.921 120.192V122.289",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.508 119.8L324.901 121.766",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.182 120.193C307.658 120.193 297.505 110.04 297.505 97.5161C297.505 84.9918 307.658 74.8389 320.182 74.8389C332.706 74.8389 342.859 84.9918 342.859 97.5161C342.859 110.04 332.706 120.193 320.182 120.193Z",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.182 117.572C309.106 117.572 300.127 108.652 300.127 97.648C300.127 86.6441 309.106 77.7236 320.182 77.7236C331.258 77.7236 340.237 86.6441 340.237 97.648C340.237 108.652 331.258 117.572 320.182 117.572Z",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.182 114.949C310.698 114.949 303.01 107.203 303.01 97.6476C303.01 88.092 310.698 80.3457 320.182 80.3457C329.665 80.3457 337.353 88.092 337.353 97.6476C337.353 107.203 329.665 114.949 320.182 114.949Z",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.182 112.853C311.856 112.853 305.107 106.045 305.107 97.6475C305.107 89.2499 311.856 82.4424 320.182 82.4424C328.507 82.4424 335.257 89.2499 335.257 97.6475C335.257 106.045 328.507 112.853 320.182 112.853Z",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.182 110.756C312.87 110.756 306.943 104.887 306.943 97.6474C306.943 90.4079 312.87 84.5391 320.182 84.5391C327.493 84.5391 333.421 90.4079 333.421 97.6474C333.421 104.887 327.493 110.756 320.182 110.756Z",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.181 108.92C313.883 108.92 308.777 103.873 308.777 97.6474C308.777 91.4218 313.883 86.375 320.181 86.375C326.48 86.375 331.586 91.4218 331.586 97.6474C331.586 103.873 326.48 108.92 320.181 108.92Z",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.182 104.726C316.2 104.726 312.972 101.557 312.972 97.6472C312.972 93.7377 316.2 90.5684 320.182 90.5684C324.163 90.5684 327.391 93.7377 327.391 97.6472C327.391 101.557 324.163 104.726 320.182 104.726Z",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.846 123.991H306.157C306.472 123.468 306.287 122.812 306.157 122.549H304.846C304.531 123.179 304.716 123.773 304.846 123.991Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.876 125.567H312.186C312.501 125.043 312.316 124.387 312.186 124.124H310.876C310.561 124.754 310.745 125.348 310.876 125.567Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.382 126.616H317.692C318.007 126.092 317.823 125.436 317.692 125.173H316.382C316.067 125.803 316.252 126.397 316.382 126.616Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.148 126.616H323.458C323.773 126.092 323.589 125.436 323.458 125.173H322.148C321.833 125.803 322.017 126.397 322.148 126.616Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.391 125.829H328.701C329.016 125.306 328.832 124.65 328.701 124.387H327.391C327.076 125.017 327.261 125.611 327.391 125.829Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.127 120.586H301.437C301.752 120.063 301.567 119.406 301.437 119.144H300.127C299.812 119.774 299.996 120.368 300.127 120.586Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.933 115.866H297.244C297.559 115.343 297.374 114.687 297.244 114.424H295.933C295.618 115.054 295.803 115.648 295.933 115.866Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.048 110.623H294.358C294.673 110.1 294.489 109.444 294.358 109.181H293.048C292.733 109.811 292.918 110.405 293.048 110.623Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.952 104.858H292.262C292.577 104.334 292.392 103.678 292.262 103.415H290.952C290.637 104.045 290.821 104.639 290.952 104.858Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.428 98.8274H291.738C292.053 98.3037 291.869 97.6476 291.738 97.3848H290.428C290.113 98.0148 290.298 98.6087 290.428 98.8274Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.214 92.7972H292.524C292.839 92.2735 292.655 91.6173 292.524 91.3545H291.214C290.899 91.9845 291.084 92.5784 291.214 92.7972Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.311 87.0296H294.621C294.936 86.5059 294.752 85.8498 294.621 85.5869H293.311C292.996 86.2169 293.181 86.8109 293.311 87.0296Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.194 81.5237H297.505C297.82 81 297.635 80.3439 297.505 80.0811H296.194C295.879 80.7111 296.064 81.305 296.194 81.5237Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.39 77.3313H301.7C302.015 76.8076 301.831 76.1515 301.7 75.8887H300.39C300.075 76.5187 300.26 77.1126 300.39 77.3313Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.37 73.6604H306.68C306.995 73.1367 306.811 72.4806 306.68 72.2178H305.37C305.055 72.8478 305.24 73.4417 305.37 73.6604Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.876 71.5608H312.186C312.501 71.0371 312.317 70.381 312.186 70.1182H310.876C310.561 70.7482 310.746 71.3421 310.876 71.5608Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.905 70.2512H318.215C318.53 69.7276 318.346 69.0714 318.215 68.8086H316.905C316.59 69.4386 316.775 70.0325 316.905 70.2512Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.934 70.5139H324.245C324.56 69.9903 324.375 69.3341 324.245 69.0713H322.934C322.619 69.7013 322.804 70.2952 322.934 70.5139Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.964 71.8255H330.275C330.59 71.3018 330.405 70.6457 330.275 70.3828H328.964C328.649 71.0128 328.834 71.6068 328.964 71.8255Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.989 81.6572L320.444 97.5184",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.927 77.3291L320.445 97.5143",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.207 74.0547L320.445 97.386",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.965 71.8242L320.313 97.3847",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.328 70.5146L320.312 97.3854",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.692 70.251L320.182 96.9913",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.056 71.5625L320.182 97.3859",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.68 73.6592L320.182 97.5162",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.831 76.8047L320.182 97.5156",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.637 80.8701L320.182 97.5179",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.754 85.8496L319.921 97.5153",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.525 91.3555L320.052 97.5154",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.214 97.3848L320.314 97.6476",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.738 103.413L319.919 97.6465",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.704 109.05L320.182 97.6455",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.588 114.426L320.312 97.5176",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.65 119.143L320.049 97.6455",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.502 122.553L320.314 97.5166",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.399 123.994L320.312 97.5166",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.136 86.5049L320.313 97.6469",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.709 92.1416L320.445 97.6474",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.232 98.0413L320.182 97.5176",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.839 103.938L320.312 97.6455",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.529 109.707L319.919 97.5176",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.515 114.948L320.445 97.6465",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.32 119.406L320.052 97.3848",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.34 122.813L320.184 97.3828",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.441 124.388L320.182 97.2539",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.804 125.172L320.182 97.3848",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.905 125.042L320.314 97.3848",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.62 76.8051L330.537 75.1016",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.164 75.3648L325.688 73.3984",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.445 72.7402V74.837",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.201 73.2666L315.595 75.233",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.22 74.8398L311.137 76.6758",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.763 77.4609L306.943 79.034",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.963 80.7373L303.536 82.18",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.817 85.0625L300.52 85.9795",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.72 89.6523L298.556 90.3085",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.541 94.7627L297.637 95.0255",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.541 100.006L297.507 99.7432",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.457 104.858L298.424 104.334",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.685 109.574L300.388 108.524",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.7 113.771L303.143 112.591",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.503 117.309L306.682 115.736",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.089 119.929L310.876 118.226",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.808 119.668L314.284 121.504",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.077 73.0039L328.704 74.1837",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.834 70.5146L323.721 73.0047",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.391 73.7909L324.375 70.1211",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.672 69.5947L318.74 72.7409",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.279 72.8742L318.346 69.5977",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.498 73.6617L316.644 69.8594",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.035 72.8734L312.316 70.251",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.746 71.3018L308.516 75.6277",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.056 74.0529L306.943 72.873",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.503 73.6592L304.323 78.5088",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.336 76.1515L301.7 75.8887",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.143 79.5576L297.507 80.0813",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.783 82.0483V77.3291",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.734 83.4902L294.097 85.4566",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.9 86.6359L297.244 81.5234",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.374 87.6865L291.868 91.3564",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.064 91.62L294.228 87.0332",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.933 92.5342L291.347 97.3838",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.525 92.667L295.408 96.7301",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.408 98.1729L291.738 103.285",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.801 101.972L291.868 98.4326",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.933 103.151L293.704 109.05",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.244 106.823L292.394 103.808",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.637 108.001L296.588 114.293",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.604 111.41L294.491 109.706",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.39 112.459L300.52 119.012",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.244 114.556L303.143 115.473",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.929 116.259L305.239 122.551",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.074 118.488L301.438 119.144",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.157 122.552L312.317 121.242",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.123 119.012L310.746 124.255",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.391 121.242L333.683 122.815",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.241 119.275L328.702 124.255",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.946 127.534L320.707 97.2539L320.184 98.9574L331.719 127.532H333.948L333.946 127.534Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.206 128.059L319.789 96.7314L320.312 98.4349L309.04 128.059H307.204H307.206Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.314 100.007C319.011 100.007 317.955 98.9509 317.955 97.6477C317.955 96.3445 319.011 95.2881 320.314 95.2881C321.618 95.2881 322.674 96.3445 322.674 97.6477C322.674 98.9509 321.618 100.007 320.314 100.007Z",
    fill: "#E8E1F3",
    stroke: "#E8E1F3",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.868 121.373L323.459 125.043",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.198 122.158L327.261 124.518",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.492 122.289L317.822 125.172",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.822 122.289L322.148 125.305",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.512 122.028L312.318 124.258",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.235 121.373L316.251 125.175",
    stroke: "#615E66",
    strokeWidth: 0.200648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.965 121.051H285.795V126.965H273.965V121.051Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.965 124.597H285.795V126.963H273.965V124.597Z",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.196 125.577H284.141V126.964H283.196V125.577Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.277 125.577H282.222V126.964H281.277V125.577Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.063 125.577H280.008V126.964H279.063V125.577Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.142 125.577H278.088V126.964H277.142V125.577Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.075 125.577H276.02V126.964H275.075V125.577Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.196 121.738H284.141V123.864H283.196V121.738Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.277 121.738H282.222V123.864H281.277V121.738Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.062 121.738H280.008V123.864H279.062V121.738Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.143 121.738H278.088V123.864H277.143V121.738Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.075 121.738H276.02V123.864H275.075V121.738Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.831 118.033L285.443 121.048H274.31L279.831 118.033Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.032 121.405L286.625 121.001L279.758 117.383L273.114 121.001L273.612 121.524L279.881 118.093L286.032 121.405Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.792 106.271L217.354 120.348V121.531L229.539 119.164L278.514 109.226L281.353 110.173L269.998 117.272L264.319 122.241C267.396 120.703 274.09 117.415 276.267 116.562C278.988 115.497 289.989 110.173 291.526 109.463C294.484 108.098 293.538 106.269 291.526 105.914C286.226 104.779 278.829 105.677 275.792 106.269V106.271Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.474 127.92H224.807L225.64 124.934C225.935 123.878 225.14 122.833 224.045 122.833H217.354V121.531L277.107 109.58C279.066 109.189 281.053 108.948 283.05 108.863C283.753 108.834 284.041 109.752 283.447 110.129L264.27 122.323C263.254 122.967 262.814 124.224 263.204 125.361L264.078 127.918H261.121V124.485C261.121 123.98 260.607 123.636 260.14 123.829L257.691 124.843V122.832L271.059 113.486C271.553 113.216 271.227 112.396 270.682 112.539C260.909 115.092 245.573 118.381 240.775 119.52C236.405 120.557 232.137 121.685 229.638 122.486C228.651 122.801 228.067 123.77 228.166 124.8L228.472 127.918L228.474 127.92Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.807 119.994V123.071",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.764 119.52V122.477",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.571 117.984V120.706",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.249 118.929V122.123",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.733 118.456V121.413",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.925 123.07L230.484 122.005",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.834 127.919V124.68C261.834 123.961 262.158 123.282 262.723 122.836C263.965 121.857 265.596 120.591 267.132 119.423C268.099 118.646 269.271 117.771 270.681 116.795C270.875 116.66 271.045 116.542 271.196 116.442C273.848 114.637 277.287 112.506 281.707 110.054C276.268 113.071 272.979 115.256 271.197 116.44H271.196C271.02 116.562 270.85 116.678 270.681 116.794C269.807 117.409 268.506 118.376 267.132 119.421C264.494 121.536 263.38 122.912 263.134 123.539V127.916H261.832L261.834 127.919Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.071 124.333L226.345 127.802H228.474C228.396 127.487 228.427 126.477 228.237 124.963C228.047 123.449 228.869 122.833 229.419 122.716L238.883 119.994L229.017 122.334C228.036 122.567 227.275 123.346 227.071 124.333Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.694 123.66L277.213 112.305L281.827 110.058",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.792 106.272L217.354 120.35V119.64L275.792 104.615C279.224 103.945 287.173 103.007 291.526 104.615C293.23 105.184 294.089 105.72 294.366 105.917C294.366 106.864 294.484 107.929 293.893 108.402C293.421 108.78 273.98 117.787 264.319 122.242C267.396 120.704 274.09 117.416 276.267 116.563C278.988 115.498 289.989 110.175 291.526 109.465C294.483 108.099 293.538 106.27 291.526 105.916C286.226 104.78 278.829 105.678 275.792 106.27V106.272Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.354 118.457V119.639L234.033 115.38C247.241 111.713 275.39 104.26 282.299 103.787C289.207 103.315 293.221 105.009 294.364 105.917V103.583C294.364 103.021 294.205 102.458 293.768 102.109C292.642 101.212 290.467 100.334 288.45 100.238C282.204 99.6693 275.122 101.263 272.361 102.13L217.354 118.455V118.457Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.354 120.23V121.532",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.706 112.542L281.706 110.058",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.481 105.444L281.824 108.876",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.157 105.917L280.641 108.994",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.45 105.444L282.772 108.876",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.997 105.561V108.992",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.116 115.035C304.548 115.035 303.277 116.306 303.277 117.875V121.424C303.277 122.992 304.548 124.263 306.116 124.263C307.684 124.263 308.956 122.992 308.956 121.424V117.875C308.956 116.306 307.684 115.035 306.116 115.035Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.761 115.863C304.454 115.863 303.395 116.923 303.395 118.23V121.542C303.395 122.849 304.454 123.909 305.761 123.909C307.069 123.909 308.128 122.849 308.128 121.542V118.23C308.128 116.923 307.069 115.863 305.761 115.863Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.236 118.229V126.983",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.462 118.939L306.118 120.596",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.773 120.831L306.116 122.488",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.773 118.939L306.116 120.596",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.869 115.035C291.301 115.035 290.029 116.306 290.029 117.875C290.029 119.443 291.301 120.714 292.869 120.714C294.437 120.714 295.708 119.443 295.708 117.875C295.708 116.306 294.437 115.035 292.869 115.035Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.868 116.1H292.631C291.389 116.1 290.384 117.106 290.384 118.347C290.384 119.589 291.391 120.594 292.631 120.594H292.868C294.111 120.594 295.116 119.587 295.116 118.347C295.116 117.105 294.109 116.1 292.868 116.1Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.986 118.229V126.983",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.331 118.465L292.988 120.122",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.523 118.465L292.867 120.122",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.332 122.387C302.332 121.377 302.124 120.379 301.722 119.454L301.318 118.527C300.534 116.727 297.981 116.727 297.197 118.527L296.793 119.454C296.389 120.379 296.183 121.377 296.183 122.387C296.183 122.639 296.387 122.844 296.639 122.844H301.878C302.129 122.844 302.334 122.639 302.334 122.387H302.332Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.504 122.273C301.504 121.449 301.332 120.634 300.997 119.881L300.805 119.45C300.072 117.798 297.729 117.798 296.995 119.45L296.803 119.881C296.47 120.634 296.296 121.449 296.296 122.273C296.296 122.522 296.499 122.727 296.751 122.727H301.048C301.298 122.727 301.502 122.524 301.502 122.273H301.504Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.256 121.068V126.865",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.718 120.595L299.256 122.014",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.439 121.305L299.257 122.607",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.198 126.85C316.297 125.859 316.141 124.092 314.885 123.31L312.8 122.013C312.478 121.814 312.069 121.821 311.757 122.035L309.908 123.297C308.711 124.116 308.552 125.82 309.577 126.845C309.59 126.857 309.608 126.864 309.626 126.864H315.158C315.172 126.864 315.189 126.859 315.2 126.848L315.198 126.85Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.2 126.848C315.189 126.859 315.172 126.864 315.158 126.864H309.626C309.608 126.864 309.59 126.857 309.577 126.845C308.552 125.82 308.711 124.116 309.908 123.297L311.757 122.035C312.069 121.821 312.478 121.814 312.8 122.013L314.885 123.31C316.141 124.092 316.297 125.859 315.198 126.85L315.2 126.848ZM315.2 126.848L315.279 126.937",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.031 126.697C315.752 125.833 315.52 124.53 314.548 123.965L312.214 122.612C311.956 122.463 311.638 122.467 311.382 122.621L309.783 123.597C308.646 124.29 308.567 125.911 309.628 126.715C309.653 126.735 309.684 126.744 309.716 126.744H314.926C314.968 126.744 315.008 126.726 315.033 126.693L315.031 126.697Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.624 124.854V126.747",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.085 124.382L312.622 125.802",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.806 125.092L312.624 126.394",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.051 126.983H288.898C288.289 126.983 287.704 126.753 287.261 126.338L286.94 126.039C286.835 125.942 286.759 125.818 286.717 125.681L286.688 125.579C286.466 124.828 287.376 124.261 287.952 124.795V124.393C287.952 123.566 288.992 123.195 289.515 123.837C289.265 122.838 290.413 122.079 291.233 122.702L291.467 122.879L291.53 122.682C291.751 121.996 292.497 121.628 293.175 121.873C293.852 122.117 294.192 122.872 293.928 123.54L293.81 123.837C294.817 123.837 295.378 124.998 294.754 125.788L294.281 126.385C293.982 126.762 293.528 126.983 293.048 126.983H293.051Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.686 126.865L293.105 124.618",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.158 125.918L291.331 124.144",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.674 126.984L288.492 125.446",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.792 125.092L288.964 125.919",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.502 126.865L292.868 122.961",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.89 115.035C126.322 115.035 125.051 116.306 125.051 117.875V121.424C125.051 122.992 126.322 124.263 127.89 124.263C129.458 124.263 130.729 122.992 130.729 121.424V117.875C130.729 116.306 129.458 115.035 127.89 115.035Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.535 115.863C126.227 115.863 125.168 116.923 125.168 118.23V121.542C125.168 122.849 126.227 123.909 127.535 123.909C128.842 123.909 129.902 122.849 129.902 121.542V118.23C129.902 116.923 128.842 115.863 127.535 115.863Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.009 118.229V126.983",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.234 118.939L127.891 120.596",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.547 120.831L127.89 122.488",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.547 118.939L127.89 120.596",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.642 115.035C113.074 115.035 111.803 116.306 111.803 117.875C111.803 119.443 113.074 120.714 114.642 120.714C116.21 120.714 117.481 119.443 117.481 117.875C117.481 116.306 116.21 115.035 114.642 115.035Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.642 116.1H114.405C113.163 116.1 112.158 117.106 112.158 118.347C112.158 119.589 113.165 120.594 114.405 120.594H114.642C115.885 120.594 116.89 119.587 116.89 118.347C116.89 117.105 115.883 116.1 114.642 116.1Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.759 118.229V126.983",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.104 118.465L114.761 120.122",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.297 118.465L114.64 120.122",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.105 122.387C124.105 121.377 123.897 120.379 123.495 119.454L123.091 118.527C122.307 116.727 119.754 116.727 118.97 118.527L118.566 119.454C118.162 120.379 117.956 121.377 117.956 122.387C117.956 122.639 118.161 122.844 118.412 122.844H123.651C123.903 122.844 124.107 122.639 124.107 122.387H124.105Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.277 122.273C123.277 121.449 123.105 120.634 122.77 119.881L122.578 119.45C121.845 117.798 119.502 117.798 118.768 119.45L118.576 119.881C118.243 120.634 118.069 121.449 118.069 122.273C118.069 122.522 118.272 122.727 118.524 122.727H122.821C123.071 122.727 123.275 122.524 123.275 122.273H123.277Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.028 121.068V126.865",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.491 120.595L121.028 122.014",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.213 121.305L121.03 122.607",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.97 126.85C138.07 125.859 137.914 124.092 136.657 123.31L134.573 122.013C134.251 121.814 133.841 121.821 133.53 122.035L131.681 123.297C130.484 124.116 130.325 125.82 131.35 126.845C131.362 126.857 131.38 126.864 131.399 126.864H136.931C136.945 126.864 136.961 126.859 136.972 126.848L136.97 126.85Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.972 126.848C136.961 126.859 136.945 126.864 136.931 126.864H131.399C131.38 126.864 131.362 126.857 131.35 126.845C130.325 125.82 130.484 124.116 131.681 123.297L133.53 122.035C133.841 121.821 134.251 121.814 134.573 122.013L136.657 123.31C137.914 124.092 138.07 125.859 136.97 126.85L136.972 126.848ZM136.972 126.848L137.052 126.937",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.804 126.697C137.524 125.833 137.293 124.53 136.32 123.965L133.986 122.612C133.729 122.463 133.41 122.467 133.155 122.621L131.556 123.597C130.419 124.29 130.339 125.911 131.4 126.715C131.426 126.735 131.456 126.744 131.489 126.744H136.699C136.74 126.744 136.78 126.726 136.806 126.693L136.804 126.697Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.397 124.854V126.747",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.858 124.382L134.396 125.802",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.58 125.092L134.397 126.394",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.825 126.983H110.671C110.062 126.983 109.477 126.753 109.034 126.338L108.713 126.039C108.608 125.942 108.532 125.818 108.49 125.681L108.461 125.579C108.239 124.828 109.149 124.261 109.725 124.795V124.393C109.725 123.566 110.765 123.195 111.288 123.837C111.038 122.838 112.186 122.079 113.007 122.702L113.24 122.879L113.303 122.682C113.524 121.996 114.27 121.628 114.948 121.873C115.625 122.117 115.965 122.872 115.701 123.54L115.583 123.837C116.59 123.837 117.151 124.998 116.527 125.788L116.054 126.385C115.755 126.762 115.301 126.983 114.821 126.983H114.825Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.459 126.865L114.879 124.618",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.932 125.918L113.104 124.144",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.448 126.984L110.265 125.446",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.565 125.092L110.738 125.919",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.275 126.865L114.641 122.961",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.648 114.319C223.08 114.319 221.809 115.591 221.809 117.159V120.708C221.809 122.276 223.08 123.547 224.648 123.547C226.216 123.547 227.488 122.276 227.488 120.708V117.159C227.488 115.591 226.216 114.319 224.648 114.319Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.293 115.146C222.986 115.146 221.927 116.205 221.927 117.512V120.824C221.927 122.132 222.986 123.191 224.293 123.191C225.601 123.191 226.66 122.132 226.66 120.824V117.512C226.66 116.205 225.601 115.146 224.293 115.146Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.768 117.512V127.922",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.993 118.222L224.768 120.195",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.306 120.117L224.768 121.655",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.306 118.222L224.768 119.759",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.132 118.575C214.564 118.575 213.292 119.846 213.292 121.415C213.292 122.983 214.564 124.254 216.132 124.254C217.7 124.254 218.971 122.983 218.971 121.415C218.971 119.846 217.7 118.575 216.132 118.575Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.132 119.643H215.895C214.653 119.643 213.648 120.649 213.648 121.89C213.648 123.132 214.654 124.137 215.895 124.137H216.132C217.374 124.137 218.379 123.13 218.379 121.89C218.379 120.648 217.372 119.643 216.132 119.643Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.25 121.771V127.804",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.595 122.008L216.252 123.665",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.787 122.008L216.13 123.665",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.288 127.805C232.288 127.805 232.33 127.754 232.35 127.729C233.136 126.713 232.9 125.195 231.761 124.486L229.677 123.189C229.355 122.99 228.946 122.997 228.634 123.211L226.783 124.473C225.702 125.212 225.469 126.673 226.188 127.705C226.211 127.738 226.26 127.805 226.26 127.805H232.287H232.288Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.913 127.665C232.623 126.812 232.395 125.526 231.435 124.969L229.134 123.634C228.879 123.487 228.563 123.491 228.315 123.643L226.738 124.606C225.615 125.291 225.536 126.89 226.584 127.683C226.608 127.701 226.639 127.712 226.671 127.712H231.808C231.85 127.712 231.888 127.694 231.915 127.663L231.913 127.665Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.499 126.029V127.804",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.962 125.559L229.499 126.978",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.682 126.268L229.5 127.57",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.583 127.805C216.583 127.805 216.32 127.625 216.202 127.515L215.884 127.216C215.777 127.118 215.701 126.995 215.661 126.858L215.63 126.756C215.407 126.005 216.318 125.438 216.894 125.972V125.57C216.894 124.742 217.935 124.371 218.459 125.014C218.209 124.015 219.355 123.256 220.179 123.879L220.413 124.056L220.474 123.859C220.697 123.173 221.441 122.805 222.12 123.049C222.797 123.294 223.138 124.049 222.872 124.717L222.754 125.014C223.759 125.014 224.322 126.175 223.697 126.964L223.227 127.562C223.156 127.652 222.987 127.805 222.987 127.805H216.583Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.777 127.806L222.046 125.794",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.277 127.012L220.272 125.319",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.343 127.806L217.432 126.623",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.734 126.268L217.829 127.137",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.587 127.806L221.809 124.139",
    stroke: "#615E66",
    strokeWidth: 0.181081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.888 115.035C334.456 115.035 335.728 116.306 335.728 117.875V121.424C335.728 122.992 334.456 124.263 332.888 124.263C331.32 124.263 330.049 122.992 330.049 121.424V117.875C330.049 116.306 331.32 115.035 332.888 115.035Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.807 126.85C322.708 125.859 322.863 124.092 324.12 123.31L326.204 122.013C326.527 121.814 326.936 121.821 327.247 122.035L329.096 123.297C330.293 124.116 330.453 125.82 329.428 126.845C329.415 126.857 329.397 126.864 329.379 126.864H323.847C323.832 126.864 323.816 126.859 323.805 126.848L323.807 126.85Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.805 126.848C323.816 126.859 323.832 126.864 323.847 126.864H329.379C329.397 126.864 329.415 126.857 329.428 126.845C330.453 125.82 330.293 124.116 329.096 123.297L327.247 122.035C326.936 121.821 326.527 121.814 326.204 122.013L324.12 123.31C322.863 124.092 322.708 125.859 323.807 126.85L323.805 126.848ZM323.805 126.848L323.725 126.937",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.974 126.697C323.253 125.833 323.485 124.53 324.457 123.965L326.791 122.612C327.049 122.463 327.367 122.467 327.623 122.621L329.221 123.597C330.359 124.29 330.438 125.911 329.377 126.715C329.352 126.735 329.321 126.744 329.288 126.744H324.079C324.037 126.744 323.997 126.726 323.972 126.693L323.974 126.697Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.38 124.854V126.747",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.919 124.382L326.382 125.802",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.198 125.092L326.38 126.394",
    stroke: "#615E66",
    strokeWidth: 0.181081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.434 100.891H102.559V127.947H59.434V100.891Z",
    fill: "#F7F5F0",
    stroke: "#615E66",
    strokeWidth: 0.167822
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0117 119.895H102.228V125.925H60.0117V119.895Z",
    fill: "#D9D9D9",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9403 119.895H96.3857V125.925H92.9403V119.895Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8911 119.895H101.337V125.925H97.8911V119.895Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4459 119.895H91.8915V125.925H88.4459V119.895Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2765 119.895H86.7219V125.925H83.2765V119.895Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1057 119.895H81.5511V125.925H78.1057V119.895Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9364 119.895H76.3818V125.925H72.9364V119.895Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7663 119.895H71.2118V125.925H67.7663V119.895Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5958 119.895H66.0413V125.925H62.5958V119.895Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5802 105.029H102.66V111.06H59.5802V105.029Z",
    fill: "#EFCDBD",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5802 105.029H102.66V105.89H59.5802V105.029Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5802 112.786H102.66V113.647H59.5802V112.786Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5802 119.895H102.66V120.755H59.5802V119.895Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5802 100.508H102.66V103.307H59.5802V100.508Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5802 100.508H102.66V101.368H59.5802V100.508Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3655 102.23H102.874V103.523H59.3655V102.23Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7823 105.029H102.228V108.907H98.7823V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9056 105.029H98.3511V108.907H94.9056V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0306 105.029H94.4761V108.907H91.0306V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1532 105.029H90.5986V108.907H87.1532V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2765 105.029H86.7219V108.907H83.2765V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3988 105.029H82.8442V108.907H79.3988V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5211 105.029H78.9666V108.907H75.5211V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6438 105.029H75.0894V108.907H71.6438V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7661 105.029H71.2117V108.907H67.7661V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8887 105.029H67.3342V108.907H63.8887V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.012 105.029H63.4575V108.907H60.012V105.029Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7823 112.786H102.228V116.232H98.7823V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9055 112.786H98.351V116.232H94.9055V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0306 112.786H94.4761V116.232H91.0306V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1531 112.786H90.5985V116.232H87.1531V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2765 112.786H86.7219V116.232H83.2765V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3987 112.786H82.8441V116.232H79.3987V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5211 112.786H78.9666V116.232H75.5211V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6437 112.786H75.0892V116.232H71.6437V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7663 112.786H71.2118V116.232H67.7663V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8887 112.786H67.3342V116.232H63.8887V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.012 112.786H63.4575V116.232H60.012V112.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.32971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5856 91.792H77.0858V100.541H59.5856V91.792Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5855 97.04H77.0857V100.541H59.5855V97.04Z",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.242 98.4883H74.6404V100.54H73.242V98.4883Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4022 98.4883H71.8005V100.54H70.4022V98.4883Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1291 98.4883H68.5273V100.54H67.1291V98.4883Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2897 98.4883H65.688V100.54H64.2897V98.4883Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2304 98.4883H62.6287V100.54H61.2304V98.4883Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2419 92.8086H74.6403V95.9534H73.2419V92.8086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4022 92.8086H71.8005V95.9534H70.4022V92.8086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1289 92.8086H68.5272V95.9534H67.1289V92.8086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2898 92.8086H65.6881V95.9534H64.2898V92.8086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2304 92.8086H62.6287V95.9534H61.2304V92.8086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2648 87.3291L76.5662 91.7892H60.1L68.2648 87.3291Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4375 92.3167L78.3135 91.7193L68.1557 86.3672L58.3247 91.7193L59.0641 92.4934L68.3379 87.4173L77.4375 92.3167Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.267873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.5909 89.416H49.29V111.827H-6.5909V89.416Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.5909 104.955H49.29V111.828H-6.5909V104.955Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.405 93.8994H46.6012V96.8887H45.405V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.23207 91.0586H50.9354V91.9551H-8.23207V91.0586Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.405 100.173H46.6012V103.162H45.405V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.107 106.449H48.0963V111.828H45.107V106.449Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9347 106.449H42.4174V111.828H37.9347V106.449Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3617 106.449H35.8444V111.828H31.3617V106.449Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7872 106.449H29.2699V111.828H24.7872V106.449Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.293 107.493C23.293 106.42 22.4239 105.551 21.3512 105.551C20.2786 105.551 19.4095 106.42 19.4095 107.493V111.827H23.2953V107.493H23.293Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4305 106.449H17.9132V111.828H13.4305V106.449Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85721 106.449H11.34V111.828H6.85721V106.449Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0143719 106.449H4.46838V111.828H-0.0143719V106.449Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.107 107.345H48.0963V111.827H45.107V107.345Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9347 107.345H42.4174V111.827H37.9347V107.345Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3617 107.345H35.8444V111.827H31.3617V107.345Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7872 107.345H29.2699V111.827H24.7872V107.345Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.293 108.391C23.293 107.318 22.4239 106.449 21.3512 106.449C20.2786 106.449 19.4095 107.318 19.4095 108.391V111.828H23.2953V108.391H23.293Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4305 107.345H17.9132V111.827H13.4305V107.345Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85721 107.345H11.34V111.827H6.85721V107.345Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0143719 107.345H4.46838V111.827H-0.0143719V107.345Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3248 93.8994H41.521V96.8887H40.3248V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3247 100.173H41.5209V103.162H40.3247V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0382 93.8994H38.2344V96.8887H37.0382V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0383 100.173H38.2345V103.162H37.0383V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.752 93.8994H34.9481V96.8887H33.752V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.752 100.173H34.9481V103.162H33.752V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.763 93.8994H31.9591V96.8887H30.763V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.763 100.173H31.9591V103.162H30.763V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1769 93.8994H28.373V96.8887H27.1769V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1768 100.173H28.3729V103.162H27.1768V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1895 93.8994H25.3856V96.8887H24.1895V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1895 100.173H25.3856V103.162H24.1895V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6029 93.8994H21.7991V96.8887H20.6029V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6028 100.173H21.799V103.162H20.6028V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0172 93.8994H18.2134V96.8887H17.0172V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0173 100.173H18.2135V103.162H17.0173V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7302 93.8994H14.9264V96.8887H13.7302V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7302 100.173H14.9264V103.162H13.7302V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.741 93.8994H11.9371V96.8887H10.741V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.741 100.173H11.9371V103.162H10.741V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15736 93.8994H8.35352V96.8887H7.15736V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15748 100.173H8.35364V103.162H7.15748V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86903 93.8994H5.06519V96.8887H3.86903V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86915 100.173H5.06531V103.162H3.86915V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.881361 93.8994H2.07751V96.8887H0.881361V93.8994Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.881361 100.173H2.07751V103.162H0.881361V100.173Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.48507 89.416H50.1866V91.2091H-7.48507V89.416Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2103 90.0127H49.2899V90.6096H44.2103V90.0127Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0411 90.0127H42.1207V90.6096H37.0411V90.0127Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8685 90.0127H34.9481V90.6096H29.8685V90.0127Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6956 90.0127H27.7753V90.6096H22.6956V90.0127Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.524 90.0127H20.6036V90.6096H15.524V90.0127Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35381 90.0127H13.4335V90.6096H8.35381V90.0127Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1809 90.0127H6.26062V90.6096H1.1809V90.0127Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2913 88.0726L19.584 88.1321L19.536 88.3722H19.2913V88.0726ZM18.0654 88.0726H17.7657V87.773H18.0654V88.0726ZM18.0654 89.5661V89.8657H17.7657V89.5661H18.0654ZM24.0416 89.5661H24.3412V89.8657H24.0416V89.5661ZM24.0416 88.0726V87.773H24.3412V88.0726H24.0416ZM22.8157 88.0726V88.3722H22.571L22.5229 88.1321L22.8157 88.0726ZM19.2913 88.3722H18.0654V87.7753H19.2913V88.3722ZM18.3627 88.0726V89.5661H17.7657V88.0726H18.3627ZM18.0654 89.2665H24.0416V89.8634H18.0654V89.2665ZM23.742 89.5661V88.0726H24.3389V89.5661H23.742ZM24.0416 88.3722H22.8157V87.7753H24.0416V88.3722ZM22.5229 88.1321C22.4132 87.5877 21.9283 87.176 21.352 87.176V86.5791C22.2188 86.5791 22.9415 87.1943 23.1085 88.0131L22.5229 88.1321ZM21.352 87.176H20.755V86.5791H21.352V87.176ZM20.755 87.176C20.1787 87.176 19.6938 87.5877 19.584 88.1321L18.9985 88.0131C19.1655 87.1943 19.8882 86.5791 20.755 86.5791V87.176Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2906 88.0712H18.0647V89.5646H24.0409V88.0712H22.815C22.6778 87.3896 22.074 86.875 21.3513 86.875H20.7543C20.0316 86.875 19.4278 87.3873 19.2906 88.0712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.103 128.254V111.222H170.234L177.106 107.188L184.279 110.026L192.796 104.946L194.44 128.254H102.105H102.103Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.895 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.688 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.479 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.273 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.858 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.652 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.445 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.238 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.031 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.824 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.617 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.203 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.997 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.789 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.581 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.374 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.167 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.96 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.752 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.546 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.34 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.132 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.925 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.718 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.511 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.304 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.097 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.891 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.684 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.475 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.268 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.061 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.854 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.646 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.44 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.234 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.026 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.819 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.613 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.405 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.198 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.992 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.785 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.578 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.368 113.612V128.254",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.162 113.165V128.255",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.955 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.748 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.541 112.418V128.256",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.252 105.992C99.0246 106.111 94.1324 104.947 92.0923 104.348C99.7129 112.117 100.907 113.61 102.252 114.358C108.527 114.955 107.032 113.462 115.101 113.462C123.17 113.462 127.652 115.554 131.835 115.703C136.019 115.852 137.064 113.462 142.146 113.462C147.228 113.462 149.915 116.899 153.353 116.899C156.79 116.899 156.639 113.313 161.271 113.164C165.902 113.016 167.995 117.796 170.236 117.796C174.57 117.796 172.329 112.865 176.66 112.716C180.995 112.568 180.844 118.393 183.682 118.393C186.52 118.393 186.372 112.865 189.958 112.417C193.544 111.968 193.395 124.968 194.44 128.104C197.279 119.886 198.624 104.348 194.44 104.348C190.257 104.348 190.555 113.462 186.971 113.61C183.385 113.759 185.626 105.99 180.846 105.393C176.066 104.796 176.066 112.117 172.329 112.414C168.594 112.714 169.339 105.393 164.111 105.393C158.883 105.393 158.284 110.921 154.249 110.921C150.215 110.921 149.021 105.393 142.146 105.393C137.514 105.393 135.124 108.83 130.939 108.83C126.753 108.83 122.019 105.477 116.297 104.945C109.872 104.348 106.286 105.841 102.252 105.99V105.992Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.058 112.569C194.197 102.528 194.787 118.545 194.437 127.808C193.392 116.153 192.345 114.929 191.748 113.614C191 111.969 189.955 112.418 189.058 112.569Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.251 119.292H103.896",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.251 124.071H103.896",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.479 116.899H109.124",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48 121.683H109.124",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48 126.462H109.124",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 116.899H112.71",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 121.683H112.71",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.066 126.462H112.71",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.652 116.899H116.297",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.652 121.683H116.296",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.652 126.462H116.296",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.238 116.899H119.882",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.238 121.683H119.882",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.238 126.462H119.882",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.824 116.899H123.469",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.824 121.683H123.469",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.824 126.462H123.469",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41 116.899H127.055",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41 121.683H127.054",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41 126.462H127.054",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.997 116.899H130.641",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.997 121.683H130.641",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.997 126.462H130.641",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.581 116.899H134.225",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.581 121.683H134.225",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.581 126.462H134.225",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.167 116.899H137.812",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.167 121.683H137.812",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.167 126.462H137.812",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.752 116.899H141.396",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.752 121.683H141.396",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.752 126.462H141.396",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.34 116.899H144.984",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.34 121.683H144.984",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.34 126.462H144.984",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.925 116.899H148.57",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.925 121.683H148.57",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.925 126.462H148.57",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.511 116.899H152.155",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.511 121.683H152.155",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.511 126.462H152.155",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.097 116.899H155.742",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.097 121.683H155.742",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.097 126.462H155.742",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.684 116.899H159.328",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.684 121.683H159.328",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.684 126.462H159.328",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.268 116.899H162.912",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.268 121.683H162.912",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.268 126.462H162.912",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.854 116.899H166.498",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.854 121.683H166.498",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.854 126.462H166.498",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.613 116.899H177.257",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.613 121.683H177.257",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.613 126.462H177.257",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.198 116.899H180.843",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.198 121.683H180.843",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.198 126.462H180.843",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.368 116.899H188.013",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.368 121.683H188.013",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.368 126.462H188.013",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.44 121.683H170.084",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.44 126.462H170.084",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.026 121.683H173.671",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.026 126.462H173.671",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.044 116.899H105.688",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.044 121.683H105.688",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.044 126.462H105.688",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.837 119.292H107.482",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.837 124.071H107.482",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.423 119.292H111.068",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.423 124.071H111.068",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.01 119.292H114.654",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.01 124.071H114.654",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.594 119.292H118.238",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.594 124.071H118.238",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.179 119.292H121.824",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.179 124.071H121.824",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.766 119.292H125.411",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.766 124.071H125.411",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.352 119.292H128.996",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.352 124.071H128.996",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.938 119.292H132.583",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.938 124.071H132.583",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.524 119.292H136.169",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.524 124.071H136.169",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.111 119.292H139.755",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.111 124.071H139.755",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.695 119.292H143.339",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.695 124.071H143.339",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.281 119.292H146.925",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.281 124.071H146.925",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.867 119.292H150.511",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.867 124.071H150.511",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.453 119.292H154.098",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.453 124.071H154.098",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.039 119.292H157.684",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.039 124.071H157.684",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.625 119.292H161.269",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.625 124.071H161.269",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.212 119.292H164.857",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.212 124.071H164.857",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.798 119.292H168.442",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.798 124.071H168.442",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.382 119.292H172.026",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.382 124.071H172.026",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.967 119.292H175.612",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.967 124.071H175.612",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.554 119.292H179.199",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.554 124.071H179.199",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.141 119.292H182.785",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.141 124.071H182.785",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.726 119.292H186.37",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.726 124.071H186.37",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.312 119.292H189.956",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.312 124.071H189.956",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.899 119.292H193.244",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.899 124.071H193.544",
    stroke: "#615E66",
    strokeWidth: 0.228711
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.244 112.567C179.13 111.544 176.061 111.222 174.268 113.612C177.257 111.519 178.734 113.047 179.647 114.06C180.992 115.554 180.992 118.641 183.981 118.243C181.291 116.002 182.039 114.209 180.246 112.567H180.244Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.584 112.659C163.939 111.529 159.178 111.671 156.936 114.958C159.775 112.268 162.972 113.309 164.257 113.762C166.798 114.658 167.544 118.045 170.533 117.647C168.187 117.05 167.976 114.304 165.584 112.659Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.178 112.568C144.259 112.019 140.501 112.12 136.018 114.81C141.247 112.717 144.444 113.46 145.729 113.913C148.27 114.81 150.063 116.603 153.199 116.751C150.853 116.154 149.313 113.465 146.178 112.568Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.628 112.267C117.49 111.967 113.3 111.83 106.286 114.36C113.906 112.866 118.128 113.477 120.18 113.612C124.214 113.877 126.925 115.563 131.835 115.705C128.166 115.142 125.589 112.74 120.628 112.267Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.8569 136.76H350.352V147.17H-18.8569V136.76Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.902 140.072L-16.8022 140.012",
    stroke: "white",
    strokeWidth: 0.335643,
    strokeDasharray: "1.68 1.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.191 127.132H350.352V131.388H-19.191V127.132Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.8569 128.333H350.352V134.012H-18.8569V128.333Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.159 134.012H273.817L299.265 132.355H329.554L350.159 134.012Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.768 134.012H208.476L230.207 132.355H260.496L297.767 134.012H297.768Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.962 134.012H83.0408L119.411 132.355H190.236L219.962 134.012Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.8569 146.995H350.352V149.68H-18.8569V146.995Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.8569 134.072H350.352V136.757H-18.8569V134.072Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.0273 101.871H77.4318V103.639H-13.0273V101.871Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7881 106.293L78.7985 104.524H-14.9532L-13.688 106.293H77.7881Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.001 106.292H77.7255V127.802H68.001V106.292Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.001 106.292H77.7255V108.356H68.001V106.292Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0667 120.143H75.6642V127.804H70.0667V120.143Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1792 118.373H76.2516V118.962H69.1792V118.373Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7116 120.142L76.183 118.963H69.2933L70.0014 120.142H75.7116Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5388 121.32H73.8955V127.802H71.5388V121.32Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9486 114.542H74.4847V115.721H70.9486V114.542Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1278 121.91H73.3073V124.858H72.1278V121.91Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.89329 106.292H68.0031V108.06H-3.89329V106.292Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.89329 108.06H68.0031V110.416H-3.89329V108.06Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4669 110.417H68.0031V127.802H64.4669V110.417Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7423 110.417H58.2784V127.802H54.7423V110.417Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1358 110.417H47.672V127.802H44.1358V110.417Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1156 110.417H37.6517V127.802H34.1156V110.417Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5706 110.417H29.1068V127.802H25.5706V110.417Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2596 110.417H19.3844V127.802H15.2596V110.417Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9471 110.417H9.95593V127.802H4.9471V110.417Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.89347 110.417H1.11536V127.802H-3.89347V110.417Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9395 108.06H68.0031V108.944H65.9395V108.06Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2349 108.943H68.0031V127.801H66.2349V108.943Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2173 108.06H58.574V108.944H56.2173V108.06Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5104 108.943H58.2784V127.801H56.5104V108.943Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6086 108.06H47.9653V108.944H45.6086V108.06Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9039 108.943H47.672V127.801H45.9039V108.943Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5914 108.06H37.9481V108.944H35.5914V108.06Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8837 108.943H37.6517V127.801H35.8837V108.943Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2778 108.06H27.6345V108.944H25.2778V108.06Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5709 108.943H27.339V127.801H25.5709V108.943Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9647 108.06H17.3214V108.944H14.9647V108.06Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2581 108.943H17.0262V127.801H15.2581V108.943Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65204 108.06H7.00879V108.944H4.65204V108.06Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94441 108.943H6.71252V127.801H4.94441V108.943Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.504 100.988L78.1671 100.104H-14.3554L-13.6924 100.988H77.504Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.504 101.871L78.1671 100.987H-14.3554L-13.6924 101.871H77.504Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9525 104.525L79.6359 103.641H-15.8207L-15.1374 104.525H78.9525Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7166 113.956C71.5769 113.956 70.6531 113.032 70.6531 111.893C70.6531 110.753 71.5769 109.829 72.7166 109.829C73.8562 109.829 74.7802 110.753 74.7802 111.893C74.7802 113.032 73.8562 113.956 72.7166 113.956Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7162 113.363C71.9029 113.363 71.2435 112.704 71.2435 111.891C71.2435 111.077 71.9029 110.418 72.7162 110.418C73.5295 110.418 74.1888 111.077 74.1888 111.891C74.1888 112.704 73.5295 113.363 72.7162 113.363Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7075 95.3906L33.086 96.5701L30.8759 100.106C31.4149 100.106 32.6733 100.077 33.3815 99.9597C34.7955 99.1343 34.6579 97.161 34.4121 96.2769L34.7075 95.3929V95.3906Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8844 95.9785L34.2629 97.0091L32.0527 100.103C32.5917 100.103 33.8502 100.079 34.5583 99.9748C35.9723 99.2531 35.8348 97.5256 35.589 96.7521L35.8844 95.9785Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0632 96.2744L35.4417 97.2329L33.2316 100.106C33.7706 100.106 35.029 100.081 35.7371 99.9865C37.1512 99.3167 37.0136 97.711 36.7678 96.9938L37.0632 96.2744Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5365 96.8643L36.915 97.6739L34.7049 100.105C35.2439 100.105 36.5023 100.085 37.2105 100.004C38.6245 99.4352 38.4869 98.0798 38.2411 97.4709L38.5365 96.8643Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.42 98.0439L37.7986 98.5604L35.5884 100.107C36.1274 100.107 37.3858 100.094 38.0939 100.042C39.508 99.6812 39.3704 98.8175 39.1246 98.4296L39.42 98.0439Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9296 95.3906L29.5511 96.5701L31.7612 100.106C31.2222 100.106 29.9638 100.077 29.2557 99.9597C27.8416 99.1343 27.9792 97.161 28.225 96.2769L27.9296 95.3929V95.3906Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7503 95.9785L28.3718 97.0091L30.5819 100.103C30.0429 100.103 28.7845 100.079 28.0763 99.9748C26.6623 99.2531 26.7999 97.5256 27.0457 96.7521L26.7503 95.9785Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.572 96.2744L27.1935 97.2329L29.4036 100.106C28.8646 100.106 27.6062 100.081 26.898 99.9865C25.484 99.3167 25.6216 97.711 25.8674 96.9938L25.572 96.2744Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0981 96.8643L25.7196 97.6739L27.9297 100.105C27.3907 100.105 26.1323 100.085 25.4241 100.004C24.0101 99.4352 24.1476 98.0798 24.3935 97.4709L24.0981 96.8643Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2137 98.0439L24.8352 98.5604L27.0453 100.107C26.5063 100.107 25.2479 100.094 24.5398 100.042C23.1258 99.6812 23.2633 98.8175 23.5091 98.4296L23.2137 98.0439Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3174 99.5149C30.2599 99.5149 29.4026 98.6577 29.4026 97.6002C29.4026 96.5428 30.2599 95.6855 31.3174 95.6855C32.3748 95.6855 33.2321 96.5428 33.2321 97.6002C33.2321 98.6577 32.3748 99.5149 31.3174 99.5149Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3173 98.9265C30.5849 98.9265 29.9912 98.3328 29.9912 97.6005C29.9912 96.8681 30.5849 96.2744 31.3173 96.2744C32.0496 96.2744 32.6433 96.8681 32.6433 97.6005C32.6433 98.3328 32.0496 98.9265 31.3173 98.9265Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5425 110.616L75.7049 110.057C75.759 109.869 75.6169 109.68 75.4185 109.68H74.6878C74.6494 109.68 74.6134 109.673 74.5818 109.66L72.8385 108.99C72.7618 108.961 72.6761 108.965 72.6017 109.001L70.7728 109.915C70.6983 109.953 70.6104 109.955 70.5314 109.924L70.2224 109.8C70.0601 109.734 69.8774 109.824 69.83 109.991L69.6497 110.611C69.6316 110.675 69.6338 110.742 69.6609 110.801L69.8594 111.299C69.8977 111.389 69.8864 111.491 69.8323 111.572L69.7038 111.766C69.6542 111.843 69.6429 111.938 69.6677 112.023L69.8729 112.634C69.9 112.72 69.8887 112.815 69.8368 112.891L69.715 113.072C69.6564 113.16 69.6497 113.273 69.697 113.367L69.8504 113.672C69.8909 113.755 69.8909 113.852 69.8504 113.936L69.679 114.274C69.6406 114.348 69.6384 114.436 69.6699 114.515L69.8549 114.984C69.8932 115.075 69.8819 115.176 69.8278 115.257L69.7286 115.406C69.6632 115.505 69.6632 115.634 69.7286 115.733L69.8211 115.868C69.8797 115.956 69.8864 116.069 69.8391 116.164L69.6857 116.468C69.6451 116.552 69.6451 116.649 69.6857 116.732L69.8594 117.077C69.8955 117.147 69.8887 117.231 69.8436 117.294C69.7489 117.438 69.8526 117.632 70.0263 117.632H75.3531C75.4523 117.632 75.5448 117.582 75.6012 117.501L75.7139 117.332C75.7726 117.244 75.7793 117.131 75.732 117.037L75.5786 116.732C75.538 116.649 75.538 116.552 75.5786 116.468L75.732 116.164C75.7793 116.069 75.7726 115.956 75.7139 115.868L75.6215 115.733C75.5561 115.634 75.5561 115.505 75.6215 115.406L75.7207 115.257C75.7748 115.176 75.7861 115.075 75.7477 114.984L75.5628 114.515C75.5313 114.436 75.5335 114.348 75.5719 114.274L75.7433 113.936C75.7839 113.852 75.7839 113.755 75.7433 113.672L75.5786 113.345C75.538 113.261 75.538 113.164 75.5786 113.081L75.75 112.743C75.7883 112.668 75.7906 112.58 75.759 112.501L75.5741 112.032C75.5358 111.942 75.547 111.841 75.6012 111.759L75.7252 111.574C75.7793 111.493 75.7906 111.392 75.7522 111.302L75.5538 110.803C75.5267 110.742 75.5245 110.675 75.5425 110.614V110.616Z",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2987 94.8027H74.7802V100.107H68.2987V94.8027Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8234 96.1969V100.105H68.296V94.9678L66.8234 96.1946V96.1969Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1266 96.9364L75.5628 99.8682C75.5357 100.008 75.4117 100.107 75.2719 100.107H43.5455C43.3831 100.107 43.25 99.9742 43.25 99.8118V99.0315C43.25 98.9638 43.2726 98.8984 43.3154 98.8466L43.7867 98.2579C43.8228 98.2128 43.8431 98.1587 43.8476 98.1023L43.983 96.756C43.9852 96.7289 43.992 96.7041 44.001 96.6793L44.3867 95.678C44.4746 95.4434 44.8196 95.4818 44.8557 95.7321C44.8941 95.9937 45.2594 96.0185 45.3338 95.7637L45.3451 95.7163C45.4196 95.466 45.7759 95.4728 45.8368 95.7253L45.9224 96.0659C45.9878 96.3275 46.3645 96.3185 46.4186 96.0546L46.4592 95.8426C46.5043 95.6284 46.8065 95.6216 46.8606 95.8336L46.8787 95.908C46.9283 96.102 47.2057 96.0952 47.244 95.899C47.2823 95.7141 47.5417 95.6938 47.6071 95.8719L47.7424 96.2508C47.8123 96.4402 48.0852 96.429 48.1371 96.235C48.198 96.0163 48.5137 96.0388 48.543 96.2621L48.5498 96.2982C48.5791 96.535 48.9151 96.5507 48.9715 96.3185L49.1136 95.7118C49.1677 95.4953 49.4699 95.4795 49.5398 95.6938L49.5939 95.8494C49.6593 96.0433 49.9413 96.0095 49.9593 95.8065C49.9773 95.6058 50.2547 95.5675 50.3224 95.7569L50.3991 95.9621C50.4735 96.1696 50.7666 96.1696 50.8411 95.9621L50.9561 95.6441C51.0328 95.4344 51.3327 95.4502 51.3891 95.6667L51.4207 95.7952C51.4703 96.0027 51.7702 95.9915 51.8063 95.7795C51.8424 95.5742 52.131 95.5539 52.1919 95.7547L52.3205 96.1809C52.3791 96.3681 52.6475 96.3568 52.6881 96.1674L52.7061 96.0839C52.7422 95.9238 52.9633 95.908 53.0219 96.0614C53.0828 96.2237 53.3218 96.1922 53.3399 96.0208V95.9937C53.3602 95.8133 53.6105 95.7817 53.6736 95.9531L53.73 96.1065C53.8044 96.3094 54.0976 96.2801 54.1314 96.0659L54.1585 95.899C54.1878 95.6983 54.4697 95.6893 54.5171 95.8855L54.5239 95.9103C54.569 96.1042 54.8486 96.0907 54.8734 95.8945L54.8892 95.7817C54.9162 95.5968 55.1846 95.5923 55.2094 95.7795C55.2388 95.9554 55.4868 95.9666 55.5274 95.7952L55.568 95.6306C55.6176 95.4299 55.9063 95.4344 55.9514 95.6374L55.9875 95.7998C56.0416 96.0478 56.3934 96.0478 56.4476 95.7998L56.4566 95.7614C56.5107 95.5133 56.858 95.5021 56.9279 95.7456L56.982 95.9283C57.0609 96.2057 57.4534 96.208 57.539 95.9306C57.6247 95.6487 58.0262 95.6554 58.1029 95.9396L58.1254 96.0298C58.2044 96.3252 58.6261 96.3207 58.696 96.0208L58.7839 95.6419C58.8403 95.4119 59.1696 95.4164 59.2147 95.6487L59.2327 95.7253C59.2778 95.9509 59.6003 95.9441 59.6364 95.7163C59.668 95.5066 59.9567 95.4773 60.0311 95.6735L60.1393 95.9554C60.2295 96.1967 60.5836 96.1538 60.6197 95.899C60.6558 95.6284 61.0392 95.6036 61.1091 95.8674L61.1497 96.0298C61.2196 96.2869 61.5804 96.3027 61.6684 96.0523L61.7089 95.9441C61.7879 95.7276 62.0969 95.7411 62.1578 95.9621C62.2232 96.1989 62.5614 96.1922 62.6178 95.9531L62.6855 95.6532C62.7396 95.4276 63.0441 95.3983 63.1388 95.6103L63.2222 95.793C63.2899 95.9463 63.5177 95.9238 63.5515 95.7592C63.5921 95.5742 63.8582 95.5787 63.8943 95.7637L63.9552 96.0681C63.9958 96.2734 64.2934 96.2643 64.3205 96.0569C64.3476 95.8494 64.6453 95.8404 64.6859 96.0456L64.7084 96.1583C64.7535 96.3771 65.0647 96.3771 65.1098 96.1583L65.1324 96.0456C65.1775 95.8178 65.5045 95.8223 65.5451 96.0501C65.5857 96.2869 65.9307 96.2688 65.96 96.0298C65.9871 95.802 66.3096 95.7704 66.3705 95.9937C66.4246 96.1854 66.6885 96.2034 66.7652 96.0208L66.7742 96.0005C66.8509 95.8268 67.099 95.8246 67.1756 95.9982L67.3425 96.3793C67.4372 96.5913 67.7281 96.6161 67.8589 96.4222L68.2446 95.8426C68.3326 95.7095 68.5333 95.7208 68.6077 95.8652C68.6956 96.0456 68.964 96.0072 69.0001 95.8088L69.0069 95.7704C69.052 95.5382 69.3789 95.5224 69.4421 95.7524L69.4534 95.802C69.512 96.014 69.8007 96.0366 69.8931 95.8381L70.1299 95.3171C70.2089 95.1457 70.4592 95.166 70.5111 95.3465L70.5855 95.6148C70.6306 95.7772 70.8674 95.7569 70.8832 95.5878C70.899 95.4209 71.1312 95.3983 71.1809 95.5584L71.2215 95.7028C71.2756 95.8742 71.5169 95.8742 71.5688 95.7028L71.6071 95.5742C71.6725 95.36 71.9792 95.3668 72.0311 95.5833L72.0582 95.6847C72.1078 95.8922 72.4055 95.8809 72.4438 95.6712C72.4799 95.4727 72.7528 95.4502 72.8249 95.6396L72.8926 95.8268C72.976 96.0569 73.3076 96.0433 73.373 95.8065L73.4136 95.6577C73.4699 95.4457 73.7676 95.4389 73.8375 95.6464C73.9029 95.8494 74.1916 95.8494 74.257 95.6464L74.2683 95.6148C74.3382 95.4028 74.6404 95.4028 74.7103 95.6148L74.814 95.926C74.8636 96.0771 75.0644 96.1132 75.1613 95.9892C75.2831 95.8404 75.5199 95.9238 75.5199 96.1155V96.6838C75.5199 96.8462 75.7229 96.9183 75.8266 96.7943C75.9416 96.6567 76.1627 96.7627 76.1311 96.9386L76.1266 96.9364Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.3122 96.9364L-11.7484 99.8682C-11.7214 100.008 -11.5973 100.107 -11.4575 100.107H20.2689C20.4313 100.107 20.5643 99.9742 20.5643 99.8118V99.0315C20.5643 98.9638 20.5418 98.8984 20.4989 98.8466L20.0276 98.2579C19.9915 98.2128 19.9712 98.1587 19.9667 98.1023L19.8314 96.756C19.8291 96.7289 19.8224 96.7041 19.8134 96.6793L19.4277 95.678C19.3397 95.4434 18.9947 95.4818 18.9586 95.7321C18.9203 95.9937 18.5549 96.0185 18.4805 95.7637L18.4692 95.7163C18.3948 95.466 18.0385 95.4728 17.9776 95.7253L17.8919 96.0659C17.8265 96.3275 17.4499 96.3185 17.3957 96.0546L17.3552 95.8426C17.3101 95.6284 17.0079 95.6216 16.9537 95.8336L16.9357 95.908C16.8861 96.102 16.6087 96.0952 16.5704 95.899C16.532 95.7141 16.2727 95.6938 16.2073 95.8719L16.072 96.2508C16.002 96.4402 15.7292 96.429 15.6773 96.235C15.6164 96.0163 15.3007 96.0388 15.2713 96.2621L15.2646 96.2982C15.2353 96.535 14.8993 96.5507 14.8429 96.3185L14.7008 95.7118C14.6466 95.4953 14.3445 95.4795 14.2746 95.6938L14.2204 95.8494C14.155 96.0433 13.8731 96.0095 13.8551 95.8065C13.837 95.6058 13.5597 95.5675 13.492 95.7569L13.4153 95.9621C13.3409 96.1696 13.0477 96.1696 12.9733 95.9621L12.8583 95.6441C12.7816 95.4344 12.4817 95.4502 12.4253 95.6667L12.3937 95.7952C12.3441 96.0027 12.0441 95.9915 12.0081 95.7795C11.972 95.5742 11.6833 95.5539 11.6224 95.7547L11.4939 96.1809C11.4352 96.3681 11.1669 96.3568 11.1263 96.1674L11.1082 96.0839C11.0721 95.9238 10.8511 95.908 10.7925 96.0614C10.7316 96.2237 10.4925 96.1922 10.4745 96.0208V95.9937C10.4542 95.8133 10.2039 95.7817 10.1407 95.9531L10.0843 96.1065C10.0099 96.3094 9.71674 96.2801 9.68291 96.0659L9.65587 95.899C9.62656 95.6983 9.34464 95.6893 9.29727 95.8855L9.2905 95.9103C9.2454 96.1042 8.96574 96.0907 8.94093 95.8945L8.92519 95.7817C8.89812 95.5968 8.62971 95.5923 8.60491 95.7795C8.57559 95.9554 8.32754 95.9666 8.28694 95.7952L8.24636 95.6306C8.19675 95.4299 7.90809 95.4344 7.86299 95.6374L7.82687 95.7998C7.77274 96.0478 7.42092 96.0478 7.3668 95.7998L7.35777 95.7614C7.30364 95.5133 6.95637 95.5021 6.88646 95.7456L6.83234 95.9283C6.75341 96.2057 6.361 96.208 6.27531 95.9306C6.18961 95.6487 5.78818 95.6554 5.7115 95.9396L5.68893 96.0298C5.60999 96.3252 5.18826 96.3207 5.11835 96.0208L5.03042 95.6419C4.97404 95.4119 4.64474 95.4164 4.59964 95.6487L4.58164 95.7253C4.53653 95.9509 4.21403 95.9441 4.17794 95.7163C4.14637 95.5066 3.8577 95.4773 3.78328 95.6735L3.67503 95.9554C3.58257 96.1967 3.23073 96.1538 3.19464 95.899C3.15856 95.6284 2.77519 95.6036 2.70528 95.8674L2.6647 96.0298C2.59479 96.2869 2.23394 96.3027 2.14599 96.0523L2.10541 95.9441C2.02648 95.7276 1.71752 95.7411 1.65663 95.9621C1.59122 96.1989 1.25293 96.1922 1.19655 95.9531L1.12889 95.6532C1.07476 95.4276 0.770304 95.3983 0.675585 95.6103L0.592115 95.793C0.524458 95.9463 0.29669 95.9238 0.262861 95.7592C0.222267 95.5742 -0.0438519 95.5787 -0.0799351 95.7637L-0.140831 96.0681C-0.181425 96.2734 -0.479084 96.2643 -0.506147 96.0569C-0.533211 95.8494 -0.830925 95.8404 -0.871519 96.0456L-0.894037 96.1583C-0.939142 96.3771 -1.25037 96.3771 -1.29547 96.1583L-1.31805 96.0456C-1.36315 95.8178 -1.69012 95.8223 -1.73071 96.0501C-1.77131 96.2869 -2.11638 96.2688 -2.14569 96.0298C-2.17276 95.802 -2.49527 95.7704 -2.55616 95.9937C-2.61028 96.1854 -2.87415 96.2034 -2.95082 96.0208L-2.95985 96.0005C-3.03653 95.8268 -3.28456 95.8246 -3.36123 95.9982L-3.52812 96.3793C-3.62284 96.5913 -3.91377 96.6161 -4.04457 96.4222L-4.4302 95.8426C-4.51816 95.7095 -4.71889 95.7208 -4.79332 95.8652C-4.88127 96.0456 -5.14964 96.0072 -5.18572 95.8088L-5.1925 95.7704C-5.2376 95.5382 -5.56459 95.5224 -5.62774 95.7524L-5.63902 95.802C-5.69766 96.014 -5.98632 96.0366 -6.07878 95.8381L-6.31559 95.3171C-6.39452 95.1457 -6.64484 95.166 -6.69671 95.3465L-6.77115 95.6148C-6.81625 95.7772 -7.05306 95.7569 -7.06885 95.5878C-7.08464 95.4209 -7.31688 95.3983 -7.3665 95.5584L-7.40713 95.7028C-7.46126 95.8742 -7.70252 95.8742 -7.75439 95.7028L-7.79277 95.5742C-7.85817 95.36 -8.16485 95.3668 -8.21672 95.5833L-8.24381 95.6847C-8.29342 95.8922 -8.5911 95.8809 -8.62944 95.6712C-8.66553 95.4727 -8.93839 95.4502 -9.01056 95.6396L-9.07823 95.8268C-9.16167 96.0569 -9.49316 96.0433 -9.55857 95.8065L-9.5992 95.6577C-9.65558 95.4457 -9.95324 95.4389 -10.0232 95.6464C-10.0886 95.8494 -10.3772 95.8494 -10.4426 95.6464L-10.4539 95.6148C-10.5238 95.4028 -10.826 95.4028 -10.8959 95.6148L-10.9997 95.926C-11.0493 96.0771 -11.25 96.1132 -11.347 95.9892C-11.4688 95.8404 -11.7055 95.9238 -11.7055 96.1155V96.6838C-11.7055 96.8462 -11.9085 96.9183 -12.0123 96.7943C-12.1273 96.6567 -12.3483 96.7627 -12.3167 96.9386L-12.3122 96.9364Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.225522,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.416 99.9569L20.3619 97.4694C20.3529 97.0499 20.0123 96.7161 19.5928 96.7161C19.1801 96.7161 18.8396 97.0431 18.8238 97.4558L18.7291 99.9569L18.6456 97.422C18.6299 97.0296 18.3074 96.7161 17.915 96.7161C17.5226 96.7161 17.2001 97.0273 17.1843 97.4198L17.0896 99.9569L16.9926 97.4423C16.9768 97.0364 16.6453 96.7161 16.2393 96.7161C15.8334 96.7161 15.4996 97.0364 15.4861 97.4423L15.3914 99.9569L15.2741 97.3543C15.2561 96.9958 14.9606 96.7139 14.6021 96.7139C14.2345 96.7139 13.9323 97.0138 13.9323 97.3837V99.9546",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9338 99.9569L13.8797 97.4694C13.8707 97.0499 13.5301 96.7161 13.1107 96.7161C12.6979 96.7161 12.3574 97.0431 12.3416 97.4558L12.2469 99.9569L12.1635 97.422C12.1477 97.0296 11.8252 96.7161 11.4328 96.7161C11.0404 96.7161 10.7179 97.0273 10.7021 97.4198L10.6074 99.9569L10.5104 97.4423C10.4946 97.0364 10.1631 96.7161 9.75717 96.7161C9.35123 96.7161 9.01744 97.0364 9.00391 97.4423L8.90921 99.9569L8.79193 97.3543C8.77389 96.9958 8.47846 96.7139 8.11988 96.7139C7.75228 96.7139 7.45009 97.0138 7.45009 97.3837V99.9546",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45056 99.9569L7.39644 97.4694C7.38742 97.0499 7.04459 96.7161 6.62737 96.7161C6.21467 96.7161 5.87415 97.0431 5.85836 97.4558L5.76366 99.9569L5.68019 97.422C5.66441 97.0296 5.34191 96.7161 4.94951 96.7161C4.5571 96.7161 4.2346 97.0273 4.21882 97.4198L4.12412 99.9569L4.02716 97.4423C4.01137 97.0364 3.67983 96.7161 3.27389 96.7161C2.86796 96.7161 2.53416 97.0364 2.52063 97.4423L2.42593 99.9569L2.30866 97.3543C2.29061 96.9958 1.99518 96.7139 1.6366 96.7139C1.269 96.7139 0.966812 97.0138 0.966812 97.3837V99.9546",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.968506 99.9569L0.914383 97.4694C0.905362 97.0499 0.562534 96.7161 0.145319 96.7161C-0.267386 96.7161 -0.607904 97.0431 -0.623691 97.4558L-0.718392 99.9569L-0.801862 97.422C-0.817648 97.0296 -1.14014 96.7161 -1.53255 96.7161C-1.92496 96.7161 -2.24745 97.0273 -2.26324 97.4198L-2.35794 99.9569L-2.4549 97.4423C-2.47069 97.0364 -2.80222 96.7161 -3.20816 96.7161C-3.6141 96.7161 -3.94789 97.0364 -3.96142 97.4423L-4.05612 99.9569L-4.1734 97.3543C-4.19144 96.9958 -4.48687 96.7139 -4.84545 96.7139C-5.21305 96.7139 -5.51524 97.0138 -5.51524 97.3837V99.9546",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1061 99.9569L76.052 97.4694C76.0429 97.0499 75.7024 96.7161 75.2829 96.7161C74.8702 96.7161 74.5297 97.0431 74.5139 97.4558L74.4192 99.9569L74.3358 97.422C74.32 97.0296 73.9974 96.7161 73.605 96.7161C73.2126 96.7161 72.8901 97.0273 72.8743 97.4198L72.7796 99.9569L72.6827 97.4423C72.6669 97.0364 72.3354 96.7161 71.9294 96.7161C71.5235 96.7161 71.1897 97.0364 71.1762 97.4423L71.0814 99.9569L70.9642 97.3543C70.9461 96.9958 70.6507 96.7139 70.2921 96.7139C69.9245 96.7139 69.6223 97.0138 69.6223 97.3837V99.9546",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6226 99.9569L69.5684 97.4694C69.5594 97.0499 69.2189 96.7161 68.7994 96.7161C68.3867 96.7161 68.0461 97.0431 68.0304 97.4558L67.9357 99.9569L67.8522 97.422C67.8365 97.0296 67.5139 96.7161 67.1215 96.7161C66.7291 96.7161 66.4066 97.0273 66.3908 97.4198L66.2961 99.9569L66.1992 97.4423C66.1834 97.0364 65.8518 96.7161 65.4459 96.7161C65.04 96.7161 64.7062 97.0364 64.6927 97.4423L64.5979 99.9569L64.4807 97.3543C64.4626 96.9958 64.1672 96.7139 63.8086 96.7139C63.441 96.7139 63.1388 97.0138 63.1388 97.3837V99.9546",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1412 99.9569L63.0871 97.4694C63.0781 97.0499 62.7376 96.7161 62.3181 96.7161C61.9054 96.7161 61.5648 97.0431 61.549 97.4558L61.4543 99.9569L61.3709 97.422C61.3551 97.0296 61.0326 96.7161 60.6402 96.7161C60.2478 96.7161 59.9253 97.0273 59.9095 97.4198L59.8148 99.9569L59.7178 97.4423C59.702 97.0364 59.3705 96.7161 58.9646 96.7161C58.5586 96.7161 58.2249 97.0364 58.2114 97.4423L58.1166 99.9569L57.9993 97.3543C57.9813 96.9958 57.6859 96.7139 57.3273 96.7139C56.9597 96.7139 56.6575 97.0138 56.6575 97.3837V99.9546",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6589 99.9569L56.6048 97.4694C56.5958 97.0499 56.2553 96.7161 55.8358 96.7161C55.4231 96.7161 55.0825 97.0431 55.0667 97.4558L54.972 99.9569L54.8886 97.422C54.8728 97.0296 54.5503 96.7161 54.1579 96.7161C53.7655 96.7161 53.443 97.0273 53.4272 97.4198L53.3325 99.9569L53.2355 97.4423C53.2197 97.0364 52.8882 96.7161 52.4823 96.7161C52.0763 96.7161 51.7425 97.0364 51.729 97.4423L51.6343 99.9569L51.517 97.3543C51.499 96.9958 51.2036 96.7139 50.845 96.7139C50.4774 96.7139 50.1752 97.0138 50.1752 97.3837V99.9546",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1754 99.9569L50.1213 97.4694C50.1123 97.0499 49.7718 96.7161 49.3523 96.7161C48.9396 96.7161 48.599 97.0431 48.5832 97.4558L48.4885 99.9569L48.405 97.422C48.3893 97.0296 48.0668 96.7161 47.6744 96.7161C47.282 96.7161 46.9595 97.0273 46.9437 97.4198L46.849 99.9569L46.752 97.4423C46.7362 97.0364 46.4047 96.7161 45.9987 96.7161C45.5928 96.7161 45.259 97.0364 45.2455 97.4423L45.1508 99.9569L45.0335 97.3543C45.0155 96.9958 44.72 96.7139 44.3615 96.7139C43.9939 96.7139 43.6917 97.0138 43.6917 97.3837V99.9546",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0667 100.987H75.6642V102.755H70.0667V100.987Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9855 101.871H57.1014C56.6143 101.871 56.2174 102.266 56.2174 102.755C56.2174 103.242 56.612 103.639 57.1014 103.639H57.9855C58.4726 103.639 58.8695 103.245 58.8695 102.755C58.8695 102.268 58.4749 101.871 57.9855 101.871Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2581 98.6301C15.2581 98.143 15.6528 97.7461 16.1422 97.7461C16.6316 97.7461 17.0262 98.1408 17.0262 98.6301V100.103H15.2581V98.6301Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9471 98.6301C4.9471 98.143 5.3418 97.7461 5.83118 97.7461C6.32056 97.7461 6.71521 98.1408 6.71521 98.6301V100.103H4.9471V98.6301Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3771 101.871H46.493C46.0059 101.871 45.609 102.266 45.609 102.755C45.609 103.242 46.0036 103.639 46.493 103.639H47.3771C47.8642 103.639 48.2611 103.245 48.2611 102.755C48.2611 102.268 47.8665 101.871 47.3771 101.871Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4373 101.871H15.5533C15.0662 101.871 14.6693 102.266 14.6693 102.755C14.6693 103.242 15.0639 103.639 15.5533 103.639H16.4373C16.9245 103.639 17.3214 103.245 17.3214 102.755C17.3214 102.268 16.9267 101.871 16.4373 101.871Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12483 101.871H5.2408C4.75367 101.871 4.35677 102.266 4.35677 102.755C4.35677 103.242 4.75367 103.639 5.2408 103.639H6.12483C6.61196 103.639 7.00891 103.245 7.00891 102.755C7.00891 102.268 6.61196 101.871 6.12483 101.871Z",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1368 97.7539C76.1468 97.8283 75.3687 98.656 75.3687 99.6641V100.106H77.1368V97.7539Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2958 97.7539C69.2858 97.8283 70.0638 98.656 70.0638 99.6641V100.106H68.2958V97.7539Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8057 98.6301C56.8057 98.143 57.2004 97.7461 57.6898 97.7461C58.1792 97.7461 58.5739 98.1408 58.5739 98.6301V100.103H56.8057V98.6301Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1972 98.6301C46.1972 98.143 46.5918 97.7461 47.0812 97.7461C47.5706 97.7461 47.9652 98.1408 47.9652 98.6301V100.103H46.1972V98.6301Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.225522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.195 131.228C338.878 131.616 341.352 132.976 342.724 133.659L342.757 135.673C342.852 135.791 343.053 136.129 343.077 136.532C343.098 136.863 342.845 137.404 342.649 137.756C342.579 137.88 342.444 137.954 342.301 137.954H322.056C321.825 137.954 321.637 137.767 321.637 137.536V136.62C321.637 135.791 322.538 135.109 323.149 134.872C323.638 134.683 325.301 134.003 326.589 133.687C326.589 133.687 328.549 131.997 331.409 131.257C333.305 130.766 335.524 130.842 337.197 131.227L337.195 131.228Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.151487
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.757 136.247C334.861 136.8 328.987 136.873 326.286 136.839V137.63H342.682C342.815 137.367 343.078 136.781 343.078 136.543C343.078 136.305 342.815 135.852 342.682 135.654C341.497 135.621 338.654 135.694 336.757 136.247Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.269 138.991C326.272 138.991 327.086 138.214 327.086 137.256C327.086 136.298 326.272 135.521 325.269 135.521C324.265 135.521 323.452 136.298 323.452 137.256C323.452 138.214 324.265 138.991 325.269 138.991Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.269 138.044C325.724 138.044 326.093 137.692 326.093 137.257C326.093 136.821 325.724 136.469 325.269 136.469C324.814 136.469 324.445 136.821 324.445 137.257C324.445 137.692 324.814 138.044 325.269 138.044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.786 133.747C331.833 133.965 327.968 133.747 327.968 133.747C330.059 132.117 332.02 131.624 333.433 131.584C337.546 131.466 338.575 132.681 338.575 132.681C338.575 132.681 336.165 133.482 333.786 133.748V133.747Z",
    fill: "url(#paint4_linear_319_33025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.141 137.457C283.408 137.007 278.798 137.044 276.947 137.069C276.471 137.075 276.02 137.274 275.692 137.616L273.921 139.471C273.921 139.471 269.165 140.097 269.165 140.558V142.318C269.06 142.447 268.84 142.82 268.812 143.263C268.788 143.628 269.066 144.222 269.285 144.61C269.361 144.748 269.509 144.828 269.667 144.828H291.959C292.214 144.828 292.419 144.623 292.419 144.368V141.537C292.419 141.082 291.432 140.884 290.757 140.784C290.082 140.685 288.385 140.48 286.969 140.132C286.969 140.132 285.995 137.678 285.141 137.457Z",
    fill: "#D7D0B3",
    stroke: "#382456",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M272.834 141.755C274.4 141.232 275.589 141.973 275.988 142.408C276.135 142.481 276.444 142.559 276.533 142.3C275.662 141.321 273.922 140.994 272.835 141.755H272.834Z",
    fill: "url(#paint5_linear_319_33025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.035 142.625C282.298 142.625 290.56 142.625 292.083 142.951V144.474H269.245C269.098 144.185 268.81 143.539 268.81 143.277C268.81 143.016 269.1 142.517 269.245 142.298C270.55 142.262 276.858 142.625 279.032 142.625H279.033H279.035Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.773 140.72L269.203 140.502L269.187 141.567L270.798 141.171C271.044 141.111 271.026 140.755 270.775 140.72H270.773Z",
    fill: "#C86A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.286 145.97C290.449 145.97 291.392 145.008 291.392 143.821C291.392 142.634 290.449 141.672 289.286 141.672C288.123 141.672 287.18 142.634 287.18 143.821C287.18 145.008 288.123 145.97 289.286 145.97Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.286 144.796C289.814 144.796 290.242 144.359 290.242 143.821C290.242 143.282 289.814 142.846 289.286 142.846C288.758 142.846 288.33 143.282 288.33 143.821C288.33 144.359 288.758 144.796 289.286 144.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.998 145.97C275.161 145.97 276.103 145.008 276.103 143.821C276.103 142.634 275.161 141.672 273.998 141.672C272.835 141.672 271.892 142.634 271.892 143.821C271.892 145.008 272.835 145.97 273.998 145.97Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.998 144.796C274.525 144.796 274.953 144.359 274.953 143.821C274.953 143.282 274.525 142.846 273.998 142.846C273.47 142.846 273.042 143.282 273.042 143.821C273.042 144.359 273.47 144.796 273.998 144.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.175 140.23H286.581L285.124 137.84L280.448 137.514H276.533L274.467 139.689C274.467 139.689 277.512 140.23 280.177 140.23H280.175Z",
    fill: "url(#paint6_linear_319_33025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.175 140.23H286.581L285.124 137.84L280.448 137.514H276.533L274.467 139.689C274.467 139.689 277.512 140.23 280.177 140.23H280.175Z",
    fill: "url(#paint7_linear_319_33025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.891 137.596H280.738V140.347H280.891V137.596Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.116529
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.982 140.198L284.861 137.861V139.015L282.947 140.198H281.982Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.883 140.23L283.607 137.719L284.248 137.804L281.384 140.23H280.883Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.302 136.227C301.914 136.227 303.221 137.534 303.221 139.146C303.221 140.758 301.914 142.065 300.302 142.065C298.689 142.065 297.382 140.758 297.382 139.146C297.382 137.534 298.689 136.227 300.302 136.227Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.301 137.322H300.545C301.822 137.322 302.856 138.357 302.856 139.633C302.856 140.91 301.82 141.943 300.545 141.943H300.301C299.024 141.943 297.991 140.908 297.991 139.633C297.991 138.356 299.026 137.322 300.301 137.322Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.18 139.511V148.511",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.884 139.755L300.18 141.458",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.6 139.755L300.304 141.458",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.194 136.227C305.807 136.227 307.114 137.534 307.114 139.146C307.114 140.758 305.807 142.065 304.194 142.065C302.582 142.065 301.275 140.758 301.275 139.146C301.275 137.534 302.582 136.227 304.194 136.227Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.194 137.322H304.438C305.715 137.322 306.749 138.357 306.749 139.633C306.749 140.91 305.714 141.943 304.438 141.943H304.194C302.917 141.943 301.884 140.908 301.884 139.633C301.884 138.356 302.919 137.322 304.194 137.322Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.073 139.511V148.511",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.775 139.755L304.072 141.458",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.491 139.755L304.195 141.458",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.086 136.227C309.698 136.227 311.005 137.534 311.005 139.146C311.005 140.758 309.698 142.065 308.086 142.065C306.474 142.065 305.167 140.758 305.167 139.146C305.167 137.534 306.474 136.227 308.086 136.227Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.086 137.322H308.33C309.607 137.322 310.64 138.357 310.64 139.633C310.64 140.91 309.605 141.943 308.33 141.943H308.086C306.809 141.943 305.775 140.908 305.775 139.633C305.775 138.356 306.811 137.322 308.086 137.322Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.965 139.511V148.511",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.668 139.755L307.965 141.458",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.384 139.755L308.088 141.458",
    stroke: "#382456",
    strokeWidth: 0.186176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4461 136.806C48.9823 136.806 50.2276 138.051 50.2276 139.587C50.2276 141.123 48.9823 142.369 47.4461 142.369C45.9098 142.369 44.6646 141.123 44.6646 139.587C44.6646 138.051 45.9098 136.806 47.4461 136.806Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4458 137.849H47.6782C48.8951 137.849 49.8797 138.835 49.8797 140.05C49.8797 141.267 48.8934 142.252 47.6782 142.252H47.4458C46.2289 142.252 45.2444 141.265 45.2444 140.05C45.2444 138.833 46.2307 137.849 47.4458 137.849Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3286 139.935V148.51",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9517 140.167L47.3286 141.79",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8228 140.167L47.4459 141.79",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1532 136.806C52.6894 136.806 53.9347 138.051 53.9347 139.587C53.9347 141.123 52.6894 142.369 51.1532 142.369C49.617 142.369 48.3717 141.123 48.3717 139.587C48.3717 138.051 49.617 136.806 51.1532 136.806Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1531 137.849H51.3855C52.6024 137.849 53.587 138.835 53.587 140.05C53.587 141.267 52.6007 142.252 51.3855 142.252H51.1531C49.9362 142.252 48.9517 141.265 48.9517 140.05C48.9517 138.833 49.938 137.849 51.1531 137.849Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0378 139.935V148.51",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6609 140.167L51.0377 141.79",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5319 140.167L51.155 141.79",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8624 136.806C56.3987 136.806 57.644 138.051 57.644 139.587C57.644 141.123 56.3987 142.369 54.8624 142.369C53.3262 142.369 52.0809 141.123 52.0809 139.587C52.0809 138.051 53.3262 136.806 54.8624 136.806Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8621 137.849H55.0945C56.3114 137.849 57.2959 138.835 57.2959 140.05C57.2959 141.267 56.3096 142.252 55.0945 142.252H54.8621C53.6452 142.252 52.6606 141.265 52.6606 140.05C52.6606 138.833 53.6469 137.849 54.8621 137.849Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3685 140.167L54.7454 141.79",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2393 140.167L54.8624 141.79",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7454 139.935V148.51",
    stroke: "#382456",
    strokeWidth: 0.177393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9413 131.238V131.646L23.3998 131.564L17.8631 130.913H11.2676C11.0878 130.913 10.9413 131.06 10.9413 131.239V131.238Z",
    fill: "#CDD9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.0654 132.623C-10.0654 131.993 -9.55436 131.482 -8.92511 131.482H33.2865C34.2837 131.482 35.2159 131.977 35.7752 132.804C36.5327 133.926 37.1303 135.148 37.5481 136.437L37.5731 136.515C37.8395 137.335 37.976 138.191 37.976 139.053V142.882C37.976 143.512 37.4649 144.023 36.8356 144.023H-8.92511C-9.55436 144.023 -10.0654 143.512 -10.0654 142.882V132.623Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4469 133.481L38.5451 133.927L37.9758 134.172C37.9758 133.427 37.2767 132.881 36.5542 133.061L36.0215 133.194L35.4521 132.462H37.1751C37.786 132.462 38.3138 132.886 38.4469 133.482V133.481Z",
    fill: "#FFF9DE",
    stroke: "#76736C",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.74084 139.381H32.0197",
    stroke: "#76736C",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07837 139.462V144.022",
    stroke: "#76736C",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4309 139.462V144.022",
    stroke: "#76736C",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7817 139.462V144.022",
    stroke: "#76736C",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9692 139.462V144.022",
    stroke: "#76736C",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0901 139.462V144.022",
    stroke: "#76736C",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8359 139.787V144.02",
    stroke: "#76736C",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.9268 138.078V137.101H25.9236C27.6166 137.101 28.4755 137.372 28.692 137.508L33.0068 139.3L35.7752 139.787H37.9743C38.0292 140.004 38.1041 140.52 37.9743 140.846C36.6708 140.928 33.5778 140.765 33.0068 140.438C30.4665 138.614 28.1476 138.104 27.3069 138.076H-8.92847L-8.9268 138.078Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98547 146.14C3.24502 146.14 4.2661 145.083 4.2661 143.778C4.2661 142.474 3.24502 141.416 1.98547 141.416C0.725909 141.416 -0.295166 142.474 -0.295166 143.778C-0.295166 145.083 0.725909 146.14 1.98547 146.14Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90408 144.836C2.48881 144.836 2.96282 144.362 2.96282 143.777C2.96282 143.193 2.48881 142.719 1.90408 142.719C1.31935 142.719 0.845337 143.193 0.845337 143.777C0.845337 144.362 1.31935 144.836 1.90408 144.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0639 146.14C28.3235 146.14 29.3446 145.083 29.3446 143.778C29.3446 142.474 28.3235 141.416 27.0639 141.416C25.8044 141.416 24.7833 142.474 24.7833 143.778C24.7833 145.083 25.8044 146.14 27.0639 146.14Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9823 144.836C27.5671 144.836 28.0411 144.362 28.0411 143.777C28.0411 143.193 27.5671 142.719 26.9823 142.719C26.3976 142.719 25.9236 143.193 25.9236 143.777C25.9236 144.362 26.3976 144.836 26.9823 144.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82555 143.209H7.52209V143.86H8.82555V143.209Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1764 143.209H13.8729V143.86H15.1764V143.209Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3662 143.209H20.0627V143.86H21.3662V143.209Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4392 140.765H31.462V141.416H32.4392V140.765Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4392 142.231H31.462V142.882H32.4392V142.231Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.92692 133.11C-8.92692 132.75 -8.63561 132.459 -8.27603 132.459H33.1682C33.8707 132.459 34.5699 132.567 35.2391 132.78L35.289 132.797C35.7585 132.947 36.1513 133.27 36.3894 133.703L37.002 134.818C37.8476 136.359 38.2155 138.119 38.0557 139.87H35.7751L33.0067 139.382L29.3427 137.838C28.3206 137.406 27.2236 137.185 26.1149 137.185H-8.92859V133.113L-8.92692 133.11Z",
    fill: "url(#paint8_linear_319_33025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6085 132.706L36.1229 133.87C36.9686 135.786 37.4047 137.857 37.4047 139.951",
    stroke: "white",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7848 137.187L29.6707 131.858H31.3687L24.7848 138.402V137.187Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7263 137.509L28.8569 131.891L29.0667 132.182L23.728 137.8V137.509H23.7263Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8405 137.187L17.7263 131.858V133.355L12.8405 138.404V137.189V137.187Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.782 137.509L16.9126 131.891L17.1223 132.182L11.7836 137.8V137.509H11.782Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.247192 137.187L5.13307 131.858V133.355L0.247192 138.404V137.189V137.187Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07837 132.459V137.383",
    stroke: "white",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4307 132.459V137.383",
    stroke: "white",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7814 132.459V137.6",
    stroke: "white",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9691 132.459V137.491",
    stroke: "white",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.09 132.459V139.462",
    stroke: "white",
    strokeWidth: 0.166469
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7637 135.825V134.144C38.7637 134.024 38.6654 133.926 38.5456 133.926H38.3009C38.0312 133.926 37.8131 134.144 37.8131 134.414V135.554C37.8131 135.824 38.0312 136.043 38.3009 136.043H38.5456C38.6654 136.043 38.7637 135.945 38.7637 135.825Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.919 11.5676H145.731C146.377 11.5676 146.902 11.0441 146.902 10.3973C146.902 9.75139 146.378 9.22687 145.731 9.22687H144.201V8.77958C144.201 6.74571 142.021 5.45599 140.239 6.43481L139.329 6.93426V6.66147C139.329 4.61857 137.709 2.90864 135.666 2.87554C133.579 2.84044 131.877 4.52229 131.877 6.60029V6.93426L131.344 6.60832C129.622 5.55528 127.605 7.4357 128.535 9.22687H126.887C126.221 9.22687 125.687 9.78148 125.718 10.4534C125.748 11.0832 126.289 11.5666 126.919 11.5666V11.5676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.091 57.9235H295.801C295.278 57.9235 294.832 57.5048 294.842 56.9832C294.852 56.4444 294.419 56.0057 293.883 56.0057H288.065C287.556 56.0057 287.126 55.6555 286.989 55.1654C286.473 53.3175 284.298 52.3114 282.506 53.3332L281.747 53.7648C281.447 53.9363 281.064 53.8063 280.929 53.4876C280.233 51.837 278.546 50.828 276.762 50.9981L276.526 51.021C274.421 51.221 272.813 52.9888 272.813 55.1025C272.813 55.6012 272.409 56.0042 271.912 56.0042H270.929C270.405 56.0042 269.96 56.423 269.97 56.9446C269.98 57.4662 269.547 57.9221 269.011 57.9221H268.692C267.987 57.9221 267.371 58.4537 267.326 59.1568C267.276 59.9271 267.886 60.5674 268.646 60.5674H271.392C271.842 60.5674 272.228 60.9275 272.219 61.3777C272.21 61.8421 272.583 62.2208 273.045 62.2208H289.417C290.33 62.2208 291.07 61.4806 291.07 60.5674H297.044C297.748 60.5674 298.364 60.0357 298.41 59.3326C298.46 58.5623 297.85 57.9221 297.09 57.9221L297.091 57.9235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9471 43.5934H51.2375C50.1434 43.5934 49.2551 42.7051 49.2551 41.6111C49.2551 40.517 50.1412 39.6287 51.2375 39.6287H61.6301V38.8704C61.6301 35.4279 65.3218 33.2441 68.3398 34.9014L69.8801 35.7464V35.1809C69.8801 31.6972 72.7053 28.8721 76.189 28.8721C79.6727 28.8721 82.4978 31.6972 82.4978 35.1809V35.7464L83.4012 35.1939C86.3173 33.4109 89.7317 36.5935 88.1589 39.6287H90.9493C92.0434 39.6287 92.9316 40.517 92.9316 41.6111C92.9316 42.7051 92.0455 43.5934 90.9493 43.5934H90.9471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.419 294.818V148.88L-0.438873 148.88V294.818L330.419 294.818Z",
    fill: "#C4E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.42 331.474V313.488L-0.437897 313.488V331.474L330.42 331.474Z",
    fill: "url(#paint9_linear_319_33025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.795 265.543L-0.868896 266.116L-0.43923 315.827H330.581L330.795 265.543Z",
    fill: "#FFF5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_33025",
    x1: -174.491,
    y1: 133.154,
    x2: -174.491,
    y2: 67.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_319_33025",
    x1: -174.491,
    y1: 133.154,
    x2: -174.491,
    y2: 67.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_319_33025",
    x1: 24.6682,
    y1: 82.5952,
    x2: 24.6682,
    y2: 145.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_319_33025",
    x1: 497.923,
    y1: 145.528,
    x2: 497.923,
    y2: 55.2391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_319_33025",
    x1: 333.271,
    y1: 131.576,
    x2: 333.271,
    y2: 133.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_319_33025",
    x1: 276.549,
    y1: 142.046,
    x2: 271.872,
    y2: 141.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_319_33025",
    x1: 274.467,
    y1: 138.872,
    x2: 286.581,
    y2: 138.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_319_33025",
    x1: 280.524,
    y1: 137.514,
    x2: 280.524,
    y2: 140.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_319_33025",
    x1: 14.5818,
    y1: 132.459,
    x2: 14.5818,
    y2: 139.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_319_33025",
    x1: 164.991,
    y1: 313.488,
    x2: 164.991,
    y2: 331.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_33025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330,
    height: 344,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroRulesBgTablet);
export default __webpack_public_path__ + "static/media/MetroRulesBgTablet.01951d2a38b4034df0df.svg";
export { ForwardRef as ReactComponent };